export default {
  en: {
    alerts: {
      aforder_status_changed: 'Your aforder status has changed to {status}',
      aforder_remark_created: 'New comment from logikoss team',
      warning: 'Warning',
      delete_user: 'Are you sure you want to delete the user?'
    },
    tables: {
      perPage: 'Per page'
    },
    buttons: {
      home: 'Home',
      quote: 'Quote',
      search: 'Search',
      add: 'Add',
      select: 'Select',
      cancel: 'Cancel',
      view_itinerary: 'View itinerary and breakdown',
      view_rate_breakdown: 'View rate breakdown',
      update: 'Update',
      close: 'Close',
      new_route: 'New Route',
      use_logicoins: 'Use Logikoins',
      logicoins_exchange: 'Exchange Logikoins',
      booking: 'Confirm Booking',
      back: 'Back',
      next: 'Next',
      send_reset_link: 'SEND RESET LINK',
      save: 'Save',
      show_privacy: 'Notify of privacy',
      terms_and_conditions: 'Terms and Conditions',
      preview_hawb: 'PREVIEW HAWB',
      preview_mawb: 'PREVIEW MAWB',
      history_quotations: 'QUOTATIONS HISTORY',
      requote: 'Requote',
      expired: 'Expired',
      select_route: 'Select Route',
      download_quote: 'DOWNLOAD QUOTE',
      download_current_status: 'DOWNLOAD CURRENT STATUS',
      show_document: 'SHOW DOCUMENT',
      edit_quote: 'Edit quote',
      new_quote: 'New quote',
      special_quote: 'Special Quote',
      no_option: 'Send data for special quote',
      request_special_quote: 'Request quote',
      desktop: 'Desktop',
      mobile: 'Mobile',
      confirm: 'Yes, confirm it',
      confirmation: 'Confirm',
      confirmDelete: 'Yes, delete it!',
      confirmSend: 'Yes, send id',
      accept: 'Accept',
      see: 'See',
      selectAnotherOption: 'Select another option',
      show_tracking: 'Tracking',
      clear_information: 'Clear information',
      view: 'View',
      edit: 'Edit',
      showTracking: 'Tracking',
      copy: 'Copy',
      file_upload: 'Select Files',
      goto_tracking: 'Go to tracking'
    },
    titles: {
      login: 'Login',
      register: 'Create an account',
      quotation: 'Make a  quotation',
      quotation_found: 'Our options for you',
      pieces: 'Pieces',
      itinerary: 'Itinerary',
      rate_breakdown: 'Rate breakdown',
      frequencies: 'Frequencies',
      detail: 'Details',
      change_password: 'CHANGE PASSWORD',
      logicoins_exchange: 'Logikoins to Exchange',
      suppliersCreate: 'CREATE SUPPLIER',
      suppliersEdit: 'UPDATE SUPPLIER',
      usersEdit: 'EDIT USER',
      usersCreate: 'CREATE USER',
      users: 'Users',
      groups: 'Groups',
      forgot_password: 'FORGOT PASSWORD',
      reset_password: 'RESET PASSWORD',
      comments: 'Comments',
      terma_and_conditions: 'TERMS AND CONDITIONS',
      notify_of_privacy: 'NOTIFY OF PRIVACY',
      date_pickup: 'PICK UP DATE',
      flight_date: 'FLIGHT DATE',
      old_bookings: 'Old Bookings',
      pickup: 'Pickup Date',
      files: 'Files',
      remarks: 'Remarks',
      requoted: 'Requoted',
      special_quote: 'Special Quote',
      expired: 'Quotation Expired',
      freight_types: 'Freight type',
      special_quote_additional_info: 'Additional information for the special quote',
      support: 'Contacts',
      suppliers: 'Suppliers',
      response: 'Response',
      description: 'Description',
      success: 'Success!',
      booking_success: 'Booking successful!',
      specialCharges: 'Special charges',
      active: 'Active',
      downloadChat: 'Download Chat',
      yourWebHookHasBeenCreated: 'Your webhook has been created',
      serverError: 'Server error, try again',
      atention: 'Atention',
      titleNotFoundInsurance: 'Cargo type not found for Insurance Quote',
      descriptionNotFoundInsurance: 'Dear customer, your insurance quotation requires that someone from our customer service personnel contacts you. You will be contacted soon.',
      physicalPerson: 'Physical person',
      moralPerson: 'Moral person',
      titleOtherCountry: 'México is not an origin or destination in insurance quote',
      descriptionOtherCountry: 'Dear customer, your insurance quotation requires that someone from our customer service personnel contacts you. You will be contacted soon.',
      titleValueMerchExceeded: 'Approval requirement for insurance for Value of the merchandise',
      descriptionValueMerchExceeded: 'Dear customer, your insurance quotation requires that someone from our customer service personnel contacts you. You will be contacted soon.'
    },
    headers: {
      booking: 'Summary',
      detailed_information: 'Detailed information',
      itinerary: {
        route: 'Route',
        flight: 'Flight',
        etd: 'ETD',
        eta: 'ETA',
        total: 'Total',
        subtotal: 'Subtotal',
        discount: 'Discount',
        rate_with_discount: 'Rate with Discount',
        rate: 'Rate',
        taxes: 'Taxes',
        cw: 'Chargeable Weight',
        density_discount: 'Density discount',
        loose_discount: 'Loose cargo discount',
        flash_discount: 'Flash Discount'
      },
      quotation_option: {
        arrange: 'Arrange by',
        transit: 'Transit time (days)',
        gross_weight: 'Gross weight (kg)',
        chargeable_weight: 'Chargeable weight (kg)',
        rate_per_kg: 'Rate per kg (USD/kg)',
        total: 'Total (USD)',
        cbm: 'CBM'
      },
      fee_breakdown: {
        text: 'The quotation includes the following:',
        gross_weight: 'Gross weight (kg)',
        volume_weight: 'Volume weight',
        chargeable_weight: 'Chargeable weight (kg)',
        rate: 'Rate per kg (USD/kg)',
        subtotal: 'Subtotal (USD)',
        tax: 'TAX (USD)',
        total: 'Total (USD)',
        regular: 'Regular',
        discount: 'Discount',
        total_discount: 'Discounted total (USD)',
        final: 'Final'
      },
      frequency: {
        route: 'Route',
        flights: 'Flights',
        frequency: 'Frequency',
        remark: 'Remark'
      },
      logicoins: 'Logikoins exchanged',
      new_total: 'New Total',
      edit_supplier: 'Edit Supplier',
      create_supplier: 'Create Supplier',
      edit_user: 'Edit User',
      create_user: 'Create User',
      edit_fiscal_address: 'Edit Fiscal Address',
      create_fiscal_address: 'Create Fiscal Address',
      charge: 'Charge',
      filterSalesByStatus: 'Filter sales by status',
      markAsRead: 'Mark as read',
      booked: 'Booked',
      selected: 'Selected',
      no_selected: 'No Selected',
      expired: 'Expired',
      shipments: 'Shipments',
      money: 'Money',
      deleted: 'Deleted!',
      error: 'Error!',
      active: 'Active',
      create_group: 'Create Group',
      edit_group: 'Edit Group',
      quote_saved: 'Your quotation has been saved successfully.',
      special_quotes: {
        revision: 'Requested',
        process: 'Process',
        refused: 'Refused',
        see: 'See',
        expired: 'Expired',
        cancelled: 'Cancelled',
        selected: 'Requested',
        sent: 'Sent',
        rejected: 'Rejected',
        booked: 'Booked',
        approved: 'Approved'
      },
      my_quotations: {
        tab_quotations: 'Quotes',
        tab_special_quotations: 'Special quotes',
        tbl_gw: 'GW (kg)',
        tbl_validity: 'Validity',
        tbl_actions: 'Actions'
      },
      preparingQuote: 'Thanks for your quote request',
      preparingQuoteText: 'You will receive your quote by email on ',
      before8am: ' before 8 AM.',
      sentInfo: ' Your quotation was sent to ',
      contactInfo: ' in case this mail address requires update contact: '
    },
    menu: {
      dashboard: 'Home',
      quote: 'Quotation',
      my_quotations: 'My quotes',
      my_bookings: 'My bookings',
      my_old_bookings: 'Old bookings',
      suppliers: 'Suppliers',
      users: 'Users',
      groups: 'Groups',
      blog: 'Blog',
      logikoins: 'Logikoins',
      financials: 'Payments',
      support: 'Contacts',
      webhooks: 'Webhooks',
      active: 'Active'
    },
    fields: {
      search: 'Search',
      actions: 'Actions',
      login: {
        email: 'Email',
        password: 'Password',
        rememberme: 'Remember me',
        forgot: 'Forgot your password?',
        dont_account: 'Don\'t have an account yet?',
        register: 'Register now',
        return: 'Return to website',
        title: 'LGK Aerial'
      },
      register: {
        text: 'Fill in the following fields to create your account',
        full_name: 'Full name',
        first_name: 'First name',
        last_name: 'Last name',
        company: 'Company',
        phone: 'Phone',
        zone: 'Zone',
        email: 'Email',
        password: 'Password',
        confirm_password: 'Confirm password',
        button: 'CREATE AN ACCOUNT',
        have_account: 'Already have an account?',
        sign_in: 'Sign in'
      },
      header: {
        profile: 'Edit profile',
        logikoins: 'Logikoins',
        support: 'Support',
        logout: 'Logout',
        drawer: {
          notifications: 'Notifications',
          markAsRead: 'Mark as read',
          all: 'All',
          unread: 'Unread | Unread ({count}) | Unread ({count})',
          read: 'Read | Read ({count}) | Read ({count})'
        },
        exchange_informative: 'Informative exchange rate'
      },
      dashboard: {
        get_started: 'Get started now',
        quote: 'Quote',
        my_quotes: 'My Quotes',
        shipment_status: 'Shipment status',
        help_from: 'Help from a representative',
        welcome: '¡Welcome,',
        latest_quotes: 'Latest quotes'
      },
      quotation: {
        origin: 'Origin',
        destination: 'Destination',
        pickup_date: 'Cargo available',
        incoterm: 'Incoterm',
        number_pieces: 'Number of pieces',
        gw: 'GW',
        cbm: 'CBM',
        weight: 'Weight',
        weight_piece: 'Weight per piece',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        freight_type: 'Type of cargo',
        pass_through_usa: 'Transit via USA allowed',
        pieces: 'Pieces',
        route: 'Route',
        gross_weight: 'Gross Weight (kg)',
        flights: 'Flights',
        frequency: 'Frequency',
        code: 'Code',
        status: 'Status',
        vw: 'Volume Weight',
        total: 'Total',
        date: 'Available Date',
        expired: 'Validity',
        action: 'Action',
        chargeable_weight: 'Chargeable Weight',
        date_quote: 'Date Quote',
        rate: 'Rate',
        type_of_measure: 'Quote by',
        dimensions: 'Piece',
        volume: 'Volume',
        lowestPrice: 'Lowest Price',
        fastestTransitTime: 'Fastest Transit Time',
        system_conversion: 'Enter the dimensions per piece, the system will calculate the volume weight.',
        unity_m3: 'm3',
        unity_centimeters: 'Centimeters',
        unity_inches: 'Inches',
        unity_kilograms: 'Kilograms',
        unity_pounds: 'Pounds',
        internal_reference_code: 'Customer reference code',
        internal_reference_code_placeholder: 'Enter code',
        pieces_placeholder: 'Enter the number of pieces',
        gross_weight_lb: 'GW (lb)',
        chargeable_weight_lb: 'Chargeable Weight (lb)',
        cargo_type_placeholder: 'Enter cargo type',
        days: 'days'
      },
      insurance: {
        fiscal_address: 'Fiscal Address',
        insurance: 'Insurance',
        tax_id: 'Tax Id',
        placeholder_tax_id: 'Enter Tax Id',
        country: 'Country',
        placeholder_country: 'Enter Country',
        street: 'Street, int. and ext. number.',
        placeholder_street: 'Enter Street',
        int: 'Int.',
        placeholder_int: 'Enter Int.',
        ext: 'Ext.',
        placeholder_ext: 'Enter Ext.',
        zipcode: 'Zipcode',
        placeholder_zipcode: 'Enter Zipcode',
        state: 'State / Province / Region',
        placeholder_state: 'Enter State / Province / Region',
        city: 'City / Location',
        placeholder_city: 'Enter City / Location',
        municipality: 'Municipality / Town hall',
        placeholder_municipality: 'Enter Municipality / Town hall',
        colony: 'Colony',
        placeholder_colony: 'Enter Colony',
        flight_number: 'Flight number',
        placeholder_flight_number: 'Enter Flight number',
        invoice: 'Merchandising invoice number',
        placeholder_invoice: 'Enter merchandising invoice number',
        name: 'Name of consignee / Beneficiary',
        placeholder_name: 'Enter the name',
        origin: 'Origin',
        placeholder_origin: 'Enter an origin',
        destiny: 'Destiny',
        placeholder_destiny: 'Enter a destination',
        typeBeneficiary: 'Type of beneficiary',
        carrier: 'Carrier',
        type: 'Type of cargo',
        category: 'Category',
        placeholder_category: 'Select the category',
        value: 'Merchandise value (USD)',
        placeholder_value: '$',
        description: 'Merchandise description',
        placeholder_description: 'Enter description',
        pieces: 'Pieces',
        placeholder_pieces: 'Enter the number of pieces',
        gw: 'GW (kg)',
        cbm: 'CBM',
        chargable_weight: 'Chargeable weight (kg)',
        weight: 'Weight(per piece)',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        placeholder_kg: 'kg',
        placeholder_m3: 'm3',
        placeholder_cm: 'cm',
        volume: 'Volume',
        dimensions: 'Dimensions (per piece)',
        download_tc: 'Download terms and conditions',
        quote: 'Quote',
        checkbox: "I can't find the type of load in the list",
        zipcode_checkbox: "I couldn't found the zipcode in the list",
        flight_date: 'Flight Date'
      },
      changePassword: {
        password: 'Password',
        new_password: 'New Password',
        new_password_confirmed: 'New Password Confirmation'
      },
      suppliers: {
        tax_id: 'Tax ID',
        company_name: 'Company Name',
        address: 'Address',
        city: 'City',
        country: 'Country',
        representative_name: 'Representative name',
        representative_phone: 'Representative phone',
        representative_email: 'Representative email',
        zip_code: 'Zip Code',
        client_id: 'Client ID',
        type: 'Type'
      },
      aforder: {
        code: 'Reservation Code',
        your_order: 'Order Number:',
        commercial_reference: 'Shipment code',
        status: 'Status',
        confirmation: 'Confirmation',
        authorization: 'Authorization',
        canceled: 'Canceled',
        deadline: 'Deadline',
        eta_warehouse: 'ETA Warehouse',
        mawb: 'MAWB',
        hawb: 'HAWB',
        eta: 'ETA',
        mawb_shipper: 'MAWB Shipper',
        mawb_consignee: 'MAWB Consignee',
        hawb_shipper: 'HAWB Shipper',
        hawb_consignee: 'HAWB Consignee',
        consolidated: 'Consolidated',
        picker: 'Picker',
        origin: 'Origin',
        destination: 'Destination',
        route: 'Route',
        incoterm: 'Incoterm',
        flight_date: 'Flight Date',
        reserve_date: 'Reservation Date',
        pieces: 'Pieces',
        weight: 'Weight',
        cbm: 'CBM',
        total_cost: 'Total Cost',
        type: 'Type',
        amount: 'Amount',
        write: 'Write..',
        date: 'Date',
        tracking: 'Tracking',
        progress: 'In progress',
        finalized: 'Finalized'

      },
      user: {
        avatar: 'Avatar',
        name: 'Name',
        email: 'Email',
        password: 'Password',
        confirm_password: 'Confirm Password',
        roles: 'Roles',
        update: 'Update',
        groups: 'Groups',
        change_image: 'Change image'
      },
      client: {
        invoicing: {
          days: 'Days',
          day: 'Day',
          documents: 'Documents included in email',
          fiscal_information: 'Fiscal Information',
          cfdi_use: 'CFDI use',
          payment_method: 'Payment Method'
        }
      },
      webhooks: {
        name: 'Name',
        event: 'Event',
        uri: 'Uri',
        api_token: 'Api Token',
        total_requests: 'Requests',
        method: 'Method',
        request_data: 'Request Data',
        response_data: 'Response Data',
        response_status_code: 'Response Status Code',
        date: 'Date'
      },
      forgotPassword: {
        email: 'Email'
      },
      invoicing: {
        folio: 'Client reference',
        currency: 'Currency',
        status: 'Status',
        doc_date: 'Doc Date',
        due_date: 'Due Date',
        payment_date: 'Payment Date',
        cancellation_date: 'Cancellation Date',
        subtotal: 'Subtotal',
        total: 'Total',
        pending_balance: 'Pending Balance'
      },
      logikoins: {
        title: 'What are Logikoins?',
        paragraph1: 'They are virtual coins that you will be able to use to pay for shipments.',
        paragraph2: 'To get them you just need to do what you do, because every shipment you transport with us you will get Logikoins.',
        paragraph3: 'So the more shipments you move, the more Logikoins you will get.',
        title_levels: 'Levels',
        levels_paragraph: 'We are looking to have a better relationship with you by recognizing your loyalty. We have 4 different levels that you will be able to reach depending on the movements you do with us. In each level you will have access to preferential rates and exclusive spaces.',
        amount: 'Amount',
        description: 'Description',
        date: 'Date',
        information: 'There is no information',
        zeppelin: '1. Zeppelin',
        zeppelin_text: 'Welcome to ZEPPELIN! You have just started your journey on our platform. As a new customer, we give you 10 Logikoins that you can redeem on your new shipments. Keep making reservations to level up.',
        plane: '2. Plane',
        plane_text: 'You obtain this level by accumulating 10 shipments or $30,000 USD in a period of 6 months, whichever comes first. To maintain this level you will have to continue with the same operations for the next 6 month period.',
        jet: '3. Jet',
        jet_text: 'You obtain this level by accumulating 20 shipments or $60,000 USD in a 6 month period, whichever comes first. To maintain this level you will have to continue with the same operations during the following 6 month period.',
        space_ship: '4. Space Ship',
        space_ship_text: 'You obtain this level by accumulating 40 shipments or $120,000 USD in a 6 month period, whichever comes first. To maintain this level you will have to continue with the same operations for the next 6 month period.',
        current_level: 'Current level',
        zeppelin_name: 'Zeppelin',
        plane_name: 'Plane',
        jet_name: 'Jet',
        space_ship_name: 'Space Ship',
        commercial_reference: 'Client Code'
      },
      notifications: {
        status: 'Status',
        title: 'Title',
        text: 'Text',
        read_at: 'Read At'
      },
      booking: {
        title: 'Booking',
        quote: 'Quote',
        route: 'Route',
        quotation_code: 'Quotation code',
        transit_time: 'Total transit time',
        transit_time_day: '0 days | 1 day | {count} days',
        air: 'Air',
        legend: 'Remaining time for your quote to expire: {days_to_expire} days',
        itinerary: 'Itinerary',
        flight: 'Flight',
        rate_breakdown: 'Rate Breakdown',
        legend_rate_breakdown: 'Rates include: ',
        exchange_logikoins: 'Exchange Logikoins',
        max_logikoins_to_use: 'Max Logikoins to use: ',
        first_remark: 'The volume discount is only valid for the dimensions and weights entered.',
        logikoins_to_use: 'Max Logikoins to use: {logikoins}'
      },
      show_aforder: {
        discount: 'Discount',
        summary: 'Summary',
        origin: 'ORIGIN:',
        destination: 'DESTINATION:',
        route: 'ROUTE:',
        pickup_date: 'PICKUP DATE:',
        estimated_departure: 'ESTIMATED DEPARTURE:',
        estimated_arrival: 'ESTIMATED ARRIVAL:',
        transit_time: 'TRANSIT TIME:',
        cargo: 'Cargo',
        number_of_pieces: '# OF PIECES:',
        gross_weight: 'GROSS WEIGHT (kg):',
        volume_weight: 'VOLUME WEIGHT (kg):',
        cbm: 'CBM',
        chargeable_weight: 'CHARGEABLE WEIGHT (kg):',
        type: 'TYPE',
        length: 'LENGTH',
        width: 'WIDTH',
        height: 'HEIGHT',
        weight: 'WEIGHT',
        charges: 'Charges',
        total: 'TOTAL:',
        rate: 'RATE:',
        chargeable_weight_charges: 'CHARGEABLE WEIGHT:',
        comments: 'COMMENTS',
        no_comments: 'No comments registered',
        message: 'Message',
        legend_comments: 'Write your message here, our operations area will answer you as quickly as possible',
        status_history: 'Status History',
        documents: 'Documents',
        itinerary: 'Itinerary',
        direct_awb: 'Direct AWB',
        mawb_consignee: 'MAWB CONSIGNEE',
        hawb_consignee: 'HAWB CONSIGNEE ',
        hawb_shipper: 'HAWB SHIPPER',
        shipment_details: 'Shipment Details',
        flight_date: 'FLIGHT DATE:',
        flight: 'FLIGHT:',
        selling_date: 'SELLING DATE:',
        payment_options_on_the_hawb: 'PAYMENT OPTIONS ON THE HAWB:',
        available: 'AVAILABLE:',
        deadline: 'DEADLINE:',
        authorization: 'AUTHORIZATION:'
      },
      status_history: {
        status: 'Status',
        date: 'Date',
        by: 'By'
      },
      documents: {
        name: 'Name',
        type: 'Type',
        actions: 'Actions'
      },
      itinerary: {
        origin: 'Origin',
        destination: 'Destination',
        number: 'Number',
        pieces: 'Pieces'
      },
      history_quotations: {
        title: 'QUOTATIONS HISTORY',
        code: 'Code',
        pieces: 'Pieces',
        volume_weight: 'Volume Weight',
        gross_weight: 'Gross Weight',
        cbm: 'CBM',
        chargeable_weight: 'Chargeable Weight',
        type: 'Type of cargo',
        transit_usa: 'Transit via USA allowed',
        rate: 'Rate',
        total_sale: 'Total Sale',
        created_at: 'Created At',
        unit: 'Unit',
        comments: 'Comments',
        quantity: 'Quantity',
        retained_taxes: 'Retained Taxes',
        transferred_taxes: 'Tansferred Taxes',
        subtotal: 'Subtotal',
        total: 'Total',
        total_usd: 'Total USD'
      },
      old_bookings: {
        gross_weight: 'Gross Weight (kg)',
        volume_weight: 'Volume Weight (kg)',
        chargeable_weight: 'Chargeable Weight (kg)',
        mawb_shipper: 'MAWB SHIPPER',
        deliveries: {
          title: 'Deliveries',
          truck: 'Truck',
          quantity: 'Quantity',
          operator: 'Operator'
        },
        sales: {
          title: 'Sales',
          currency: 'Currency',
          type: 'Type',
          exchange_rate: 'Exchange Rate',
          comments: 'Comments',
          sale_concept: 'Sale Concept',
          quantity: 'Quantity',
          rate: 'Rate',
          unit: 'Unit',
          transferred_taxes: 'Transferred Taxes',
          retained_taxes: 'Retained Taxes',
          subtotal: 'Subtotal',
          total: 'Total'
        }
      },
      blog: {
        air_import: {
          title: 'Air Import Sales Manual',
          text: 'A common question from freight forwarders is what rate should I offer my client? The answer must consider several factors such as:',
          first: 'Product load type',
          second: 'Industry type',
          third: 'Size of the company',
          text2: 'As part of our commitment to freight forwarders, we conducted a study to answer this basic question. Download the following document to learn more.'
        },
        how_quote: {
          title: 'How to quote?',
          text: 'Do you have any questions to quote? Follow these simple steps and get amazing quotes.'
        }
      },
      financials: {
        invoicing: {
          title: 'Invoicing',
          summary: 'Summary',
          fiscal_address: 'Fiscal Address'
        },
        billing_information: {
          title: 'BILLING INFORMATION',
          subtitle: 'Billing Information',
          cfdi_use: 'CFDI use: ',
          payment_method: 'Payment Method: ',
          documents: 'Documents: ',
          fiscal_information: 'Fiscal Information',
          periodicity: 'Periodicity'
        },
        bank_accounts: {
          title: 'BANK ACCOUNTS',
          subtitle: 'Bank Accounts',
          company_information: 'Company Data: ',
          business_name: 'Business Name: ',
          rfc: 'Federal taxpayer registration: ',
          fiscal_address: 'Fiscal Address: ',
          phone: 'Phone: ',
          email: 'Email: ',
          contact: 'Contact: ',
          freight_payment: 'Freight Account',
          bank: 'Bank: ',
          beneficiary: 'Beneficiary: ',
          account_number: 'Account Number: ',
          branch_name: 'Branch Name: ',
          branch_number: 'Branch Number: ',
          bank_located: 'State or city where the bank is located: ',
          clabe_interbank: 'CLABE interbank: ',
          currency: 'Currency: ',
          payment_reva: 'Revalidation Payment'
        }
      },
      special_quote: {
        origin_country: 'Origin country',
        origin_region: 'Origin region',
        origin_city: 'Origin city',
        destination_country: 'Destination country',
        destination_region: 'Destination region',
        destination_city: 'Destination city',
        zip_code: 'Zip Code',
        deadline: 'Deadline',
        nature_charge: 'Nature Charge',
        pickup_date: 'Available from',
        address: 'Address',
        pickup_address: 'Pickup address',
        pickup_address_placeholder: 'Enter pickup address',
        other_freight_type: 'Other',
        destination_airport: 'Destination airport',
        origin_airport: 'Origin airport',
        available_date: 'Available cargo date',
        available_date_provided: 'Available cargo date provided',
        available_date_not_provided: 'Available cargo date not provided',
        available_date_not_provided_warning: 'Rates are provided considering the currently available rate, subject to validity and change when the cargo becomes available.',
        service: 'Cargo type',
        contains_batteries: 'Contains Lithium batteries?',
        commodity: 'Commodity description',
        service_warning: 'For DG cargo, provide an updated MSDS. For Mainland China, an SRICI/PONY certificate or a certificate validated by a Chinese certifying organization is required. MSDS will not be valid in China when generating the booking.',
        services_options: {
          general_cargo_stackable: 'General Cargo / Stackable',
          general_cargo_no_stackable: 'General Cargo / NO Stackable',
          overweight_oversized: 'Overweight / Oversized',
          dangerous_goods: 'Dangerous Goods',
          perishable: 'Perishable'
        },
        batteries_options: {
          no_batteries: 'No batteries',
          lithium_ion: 'ELI - UN3481 - Lithium ion batteries - Section II',
          lithium_metal: 'ELM - UN3091 - Lithium metal batteries - Section II',
          combination: 'UN3481/UN3091 - combination - Section II'
        },
        deadline_arrival: 'Arrival deadline',
        internal_reference: 'Internal reference code'
      },
      remarks: {
        remark: 'Remark',
        enter_remark: 'Enter your remark'
      },
      file: {
        type: 'Type',
        file: 'File',
        comments: 'Comments',
        attach_file: 'Attach files'
      },
      support: {
        contact_title: 'Contact Info',
        text: 'Contact us if you have any questions.',
        phone: 'Phone',
        title_quotation_question: 'Do you have any question about quoting?',
        text_quotation_question: 'Follow these simple steps and get amazing quotes.',
        show_document: 'Show document'
      },
      mega_sale_status: {
        all: 'ALL',
        paid: 'PAID',
        pending: 'PENDING',
        canceled: 'CANCELED',
        cancellation: 'CANCELLATION IN PROCESS',
        partial_paid: 'PARTIAL PAID'
      },
      address: {
        legal_name: 'Legal Name',
        tax_id: 'Tax Id',
        city: 'City',
        street: 'Street',
        no_ext: ' No. Ext.',
        colony: 'Colony',
        municipality: 'Municipality',
        state: 'State',
        zip_code: 'Zip Code',
        country: 'Country',
        no_int: 'No. Int.',
        alias: 'Alias',
        responsable: 'Responsible',
        reference: 'References',
        locality: 'Locality',
        alias_placeholder: 'Datum to identify the address.'
      },
      group: {
        name: 'Name',
        users: 'Users'
      }
    },
    messages: {
      question_contact: 'Do you have any questions about quoting?',
      text_contact: 'Contact our advisors',
      login_header: 'Please fill in your details below in order to log in.',
      quotation_option: 'At the moment we do not have any option for this route please try a new route',
      change_password: 'If you want to use this application you need to change your password',
      password_changed: 'You need to log in again whenever the password has been modified',
      session_expired: 'Your password has expired, you need to log in again to change it',
      logicoins_to_use: 'You can use {logicoins_to_use} logikoins',
      gain_logicoins: 'Book now and get {gain_logicoins} Logikoins',
      forgot_password: 'If you forgot your password it is necessary to reset it, write your email below and you will receive an email to perform this action',
      reset_password: 'To reset your password it is necessary to fill out the following form',
      expire_days: 'Remaining time for your quote to expire: {expire_days} days',
      direct_awb: 'To fill automatically, complete the information in this link:',
      disclaimer_oldbooking: 'Dear customer, welcome to the new logikoss.com platform. The details of the shipments booked in the previous version can be found here.',
      membership_next_level: 'If you moved up to Category {next_membership} you would be paying ',
      saving_money: 'saving {saving_money} USD',
      empty_remarks: 'No comments registered',
      placeholder_comment: 'Write your message here, our operations area will answer you as quickly as possible',
      booked: 'The quotation has ready booked',
      under_authorization: 'This quote is waiting to be approved',
      options: 'We have {option} options for you',
      noOptionsFCA: 'We don´t have options FCA for you',
      optionsFCA: 'We have {option} options FCA for you',
      optionsEXW: 'We have {option} options EXW for you',
      options_single: 'We have {option} option for you',
      options_singleFCA: 'We have {option} option FCA for you',
      options_singleEXW: 'We have {option} option EXW for you',
      discount_availability: 'Discount subject to availability',
      booking_before: 'Booking before: ',
      tooltipCreateWebhook: 'Create Webhook',
      tooltipEdit: 'Edit',
      tooltipDelete: 'Delete',
      tooltipWebhookCredentials: 'Webhook Credentials',
      aforderStatusChanged: 'Notification when there is a change of status of a shipment',
      aforderWeightsUpdated: 'Notification when there is an update of weights of a shipment',
      aforderItineraryUpdated: 'Notification when there is a change of itinerary of a shipment',
      aforderQuotationSalesUpdated: 'Notification when there is an update in the price of a sale',
      aforderUploadFile: 'Notification when a shipping document was added',
      aforderUpdated: 'Notification when there is an update of a shipment',
      aforderAuthorized: 'Notification when a shipment is authorized',
      requoted: 'Your quote has been requoted due to its expiration date',
      aforderDeliveryUpdated: 'Notification when there is a delivery update of a shipment',
      expired: 'Your quotation has expired. Please quote it again to get new rates.',
      thisQuotationHasBeenSavedWithCode: 'This quotation has been saved with code',
      itWillBeValidFor: 'It will be valid for',
      areYouSure: 'Are you sure?',
      confirmBookingText1: 'The selected route uses passenger flights. Make sure that the maximum dimensions per piece are',
      bookingConfirmedText1: 'This shipment has been booked under the code:',
      bookingConfirmedText2: 'You can keep up with its updates in tracking',
      stpRemark: 'If the cargo contains: audio and sound equipment, electrical equipment, household appliances or motors, extra costs may apply for up to',
      allRightsReserved: 'All rights reserved',
      nextLevelShipments: 'you have {current} shipments, you only need {missing} shipments to reach the next level',
      nextLevelAmount: 'You have {current} USD, only {missing} USD left to reach the next level',
      dataHasBeenDeleted: 'Data has been deleted.',
      dataHasNotBeenDeleted: 'Data has not been deleted.',
      youWontBeAbleToRevertThis: 'you won\'t be able to revert this',
      noOptions: 'No options for you quotation',
      stpSend: 'Your special quote has been sent',
      noSTPSaved: 'No quotes has been saved',
      quoteSaved: 'Your quote has been saved',
      whichGroupQuoteAssigned: 'To which group will this quote be assigned?',
      firstSelectDateItineray: 'You must first select a date from the itinerary',
      quoteHasBeenSentForAuth: 'This quote has been sent for authorization',
      defaultAirportError: 'Contact administrator to validate origin.'
    },
    countries: {
      mexico: 'Mexico',
      colombia: 'Colombia',
      ecuador: 'Ecuador',
      chile: 'Chile',
      brasil: 'Brazil'
    },
    support: {
      sales_director: 'Sales Director',
      commercial_director: 'Commercial Director',
      general_manager: 'General Manager',
      bussiness_development: 'Bussiness Development'
    },
    screnNewQuotation: {
      departure_city: 'Departure City',
      detination_city: 'Destination City',
      quote_edit: 'Edit',
      new_quote: 'New quote',
      pieces: 'Pieces',
      gross_weight: 'Gross weight (kg)',
      cbm: 'CBM (m3)',
      loadable_weight: 'Chargeable weight (kg)',
      density: 'Density (kg/CBM)',
      origin: 'Origin',
      destination: 'Destination',
      pass_through_usa: 'Transit via USA allowed',
      download_quotation: 'Download quote',
      searchResult: 'Your research results',
      options: 'We have <span style="font-weight: 500">{option}</span> options for you',
      noOptionsFCA: 'We don´t have options FCA for you',
      noOptionsEX: 'We don´t have options EXW for you',
      optionsFCA: 'We have <span style="font-weight: 500">{option}</span> options FCA for you',
      optionsEXW: 'We have <span style="font-weight: 700">{option}</span> options EXW for you',
      options_single: 'We have <span style="font-weight: 500">{option}</span> option for you',
      options_singleFCA: 'We have <span style="font-weight: 500">{option}</span> option FCA for you',
      options_singleEXW: 'We have <span style="font-weight: 700">{option}</span> option EXW for you',
      flightDate: 'Flight Date',
      quotation_option: 'At the moment we do not have any option for this route please try a new route',
      consolidation: 'Consolidated',
      route: 'Route',
      airline: 'Airline',
      discount_density: 'DENSITY DISCOUNT',
      discount_density_detail: 'Valid for details, dates and route described, MAWB consigned to Logikoss',
      volume_discount: 'VOLUMETRIC DISCOUNT',
      volume_discount_detail: 'Volume discount applies to cargo with the specified details and consigned to Logikoss',
      consolidation_discount: 'CONSOLIDATION BENEFIT',
      loose_charge: 'LOOSE CARGO DISCOUNT',
      capacity: 'Total Capacity',
      available_capacity: 'Available Capacity',
      pickup: 'Pickup',
      more_information: 'More information',
      table: {
        rate: 'Rate',
        cost: 'Total',
        normal: 'Normal',
        discount: 'Discount',
        final: 'Final'
      },
      remark_consolidation: 'Consolidation benefit valid for the details, date, and route specified. MAWB consigned to Logikoss.'
    },
    newQuote: {
      departure_city: 'Origin',
      detination_city: 'Destination',
      calendar: 'Calendar',
      fe_per_kg: 'Rate per kilo',
      total_cost: 'Total cost',
      options: 'We have {option} options for you',
      noOptionsFCA: 'We don´t have options FCA for you',
      noOptions: 'We don´t have options',
      optionsFCA: 'We have {option} options FCA for you',
      optionsEXW: 'We have {option} options EXW for you',
      options_single: 'We have {option} option for you',
      options_singleFCA: 'We have {option} option FCA for you',
      options_singleEXW: 'We have {option} option EXW for you',
      pickup: 'Pickup',
      flight: 'Flight',
      days: 'Days',
      day: 'Day',
      itinerary: 'Itinerary',
      air: 'Air',
      maritime: 'Maritime',
      carrier: 'Carrier',
      best_rate: 'Best Rate Available',
      total_consolidated: 'Total All In Consolidated',
      show_information: 'Show information',
      less_information: 'Less information',
      expiration_at: 'Booking deadline'
    },
    newTrackingPresentation: {
      selectAnOrderNumber: 'Select an order number',
      noDataAvailable: 'No data available',
      cargoHistory: `History`,
      cargoArrived: 'Your cargo arrives on',
      origin: 'Origin',
      destination: 'Destination',
      shipmentDetails: 'Shipment Details',
      incoterm: 'Incoterm',
      weight: 'Weight',
      chargeableWeight: 'Chargeable Weight (kg)',
      density: 'Density',
      pieces: 'Pieces',
      remark: 'Cargo details are different than the ones when booking the shipment',
      viewDetails: 'View history',
      cargoDetailHistory: 'Schedule history',
      dateWhenChangeWasMade: 'Date when change was made',
      comments: 'Comments',
      backToCurrentSchudule: 'Back to current schedule',
      noChangesYet: 'No changes yet',
      galleryMedia: 'Gallery Media',
      schedule: 'Schedule',
      shareTracking: "Share cargo's tracking",
      shareTrackingByEmail: "Share cargo's tracking by email",
      sendByEmail: 'Send by email',
      downloadPDF: 'Download PDF',
      scheduleHistory: 'Schedule history',
      scheduleBottomText: 'This schedule is different than the one booked',
      ps: 'PCS',
      kg: 'Kg',
      fn: 'Flight/Truck',
      sheduleDivider: 'Cargo divided: The cargo has been divided into the following routes',
      sendByWhatsapp: 'Send by Whatsapp',
      sendWhatsappMessage: 'Send Whatsapp Message',
      send: 'Send',
      client: 'Client',
      whatsappMessage: 'In the PDF you can find the current status of the shipment',
      download: 'Download',
      itsEmpty: 'It is empty',
      of: 'of',
      cargoOnBoard: 'Cargo confirmed on board',
      cargoNoOnBoard: 'Cargo not confirmed on board',
      messageP1: 'Dear Customer',
      messageP2: 'Receive attached the tracking of your shipment',
      messageP3: 'With the following features',
      subject: 'Subject',
      to: 'To',
      lastSystemUpdate: 'Last system update',
      withoutItineraryCargoNotReady: 'Without itinerary, cargo not ready'
    },
    insurance: {
      modal: {
        title: 'Quote shipping insurance',
        title2: 'Confirm shipping insurance',
        title3: 'Insurance policy',
        title4: 'Shipping insurance quote',
        subtitle: 'Shipment Insurance',
        subtitle2: 'Your insurance was successfully contracted',
        subtitle3: 'Your insurance quote was successfully saved',
        text1: 'Shipping insurance coverage:',
        text2: 'Now you can see your Insurance quotes in My quotes',
        step1: 'Quotation',
        step2: 'Purchase',
        step3: 'Confirmation',
        here: 'Here',
        tc: 'Terms and conditions',
        download_tc: 'Download the terms and conditions',
        download_insurance: 'Download your insurance policy',
        title_alert: 'Confirm insurance',
        message_alert: 'Are you sure you want to confirm the purchase of your shipment insurance?',
        continue: 'Continue quoting',
        btn_continue: 'Continue',
        btn_save: 'Save',
        btn_cancel: 'Cancel',
        btn_back: 'Back',
        btn_hire: 'Purchase',
        btn_confirm: 'Confirm',
        btn_create: 'Create User',
        go_to_insurance: 'Go to my insurance quotes',
        go_to_hire: 'Go to my contracted insurance',
        bnt_finish: 'Finish',
        disclaimer: 'DISCLAIMER: ALL TERMS THAT APPEAR IN ENGLISH AND THAT ARE MENTIONED WITHIN THIS WEBSITE, FOR QUOTE AND ISSUANCE OF THE INSURANCE CERTIFICATE AND/OR ANY DOCUMENT AND/OR PROCESS RELATED TO INSURANCE ISSUES ARE JUST A REFERENCE AS A COURTESY. FOR ANY DISCREPANCIES AND OBSERVATIONS THAT MAY EXIST, THE SPANISH VERSION SHOULD AND WILL ALWAYS PREVAIL.'
      },
      quoteTable: {
        tab: 'Insurance quote',
        noQuote: 'Quote No.',
        origin: 'Origin',
        destiny: 'Destination',
        value: 'Merchandise value (USD)',
        total: 'Total insurance',
        expires: 'Expires in',
        tyc: 'Terms and conditions',
        action: 'Action',
        download: 'Download',
        confirm: 'Confirm'
      },
      bookingTable: {
        tab: 'Contracted insurance',
        tabAforder: 'Current reservations',
        noQuote: 'No. Quote',
        noPolicy: 'No. Certificate',
        origin: 'Origin',
        destiny: 'Destination',
        value: 'Merchandise value (USD)',
        date: 'Reservation date',
        insuranceCarrier: 'Insurance carrier',
        codeClient: 'Client code',
        actions: 'Damage guide'
      },
      general: {
        quote: 'Quote insurance',
        insuranceHired: 'Insurance hired',
        insuranceQuoted: 'Insurance quoted'
      }
    },
    unique_quote: {
      button_ok: 'Ok',
      contains_batteries: 'Contains Lithium batteries?',
      contains_batteries_placeholder: 'Select',
      commodity: 'Commodity description',
      commodity_placeholder: 'Enter description',
      quotation_tab: 'Cargo quote',
      insurance_tab: 'Insurance quote',
      general_information: 'General Information',
      origin_placeholder: 'Enter the origin',
      destination_placeholder: 'Enter the destination',
      available_on_placeholder: 'yyyy/mm/dd',
      incoterm_placeholder: 'Enter the incoterm',
      cargo_type: 'Cargo type',
      pass_via_usa: 'Transit via USA allowed',
      rules: {
        gw_total: 'Min value allowed {min} ',
        density: 'The density must be between {min} and {max} ',
        max_value: 'Max value allowed {max} '
      },
      modalSpecialQuoteTitle: 'The characteristics of your cargo exceed the pre-established limits',
      modalSpecialQuoteNotDetails: 'Provide the details per piece of your cargo.',
      modalSpecialQuoteBody: 'Please provide additional information so we can prepare a tailor-made quotation for your request.',
      origin_airport: 'Origin airport',
      gw: 'GW',
      vw: 'VW',
      cw: 'CW',
      volume: 'Volume',
      density: 'Density',
      pure_batteries: 'Pure Batteries are not allowed',
      remark_placeholder: 'Enter your comment',
      file_placeholder: 'Pictures or further information',
      file_advice: 'If your cargo exceeds the allowed weight or is oversized, provide pictures or further information about your cargo',
      cancel: 'Cancel',
      send_request: 'Send request',
      adviceOverweightTitle: 'Your shipment is Overweight/Oversized',
      adviceOverweightBody: 'If available, please provide pictures and information of your cargo.',
      adviceDGTitle: 'Your shipment is a DG',
      adviceDGBody: 'Please provide Commodity description and support documents',
      continue: 'Continue quoting'
    }
  },
  es: {
    unique_quote: {
      button_ok: 'Aceptar',
      contains_batteries: '¿Contiene baterías de litio?',
      contains_batteries_placeholder: 'Seleccione',
      commodity: 'Descripción del producto',
      commodity_placeholder: 'Ingresar descripción',
      quotation_tab: 'Cotizar carga',
      insurance_tab: 'Cotizar seguro',
      general_information: 'Información general',
      origin_placeholder: 'Ingresa el origen',
      destination_placeholder: 'Ingresa el destino',
      available_on_placeholder: 'yyyy/mm/dd',
      incoterm_placeholder: 'Ingresa el incoterm',
      cargo_type: 'Tipo de carga',
      pass_via_usa: 'Tránsito permitido por EEUU',
      rules: {
        gw_total: 'Valor mínimo permitido {min} ',
        density: 'La densidad debe estar entre {min} y {max} ',
        max_value: 'Valor máximo permitido {max} '
      },
      modalSpecialQuoteTitle: 'Las características de tu carga exceden los límites preestablecidos',
      modalSpecialQuoteNotDetails: 'Proporcione los detalles por pieza de su carga.',
      modalSpecialQuoteBody: 'Proporcione información adicional para que podamos realizar una cotización personalizada para su solicitud.',
      origin_airport: 'Aeropuerto de origen',
      gw: 'GW',
      vw: 'VW',
      cw: 'CW',
      volume: 'Volumen',
      density: 'Densidad',
      pure_batteries: 'No se permiten baterías puras',
      remark_placeholder: 'Ingresa tus comentarios',
      file_placeholder: 'Fotografías o más informaicón',
      file_advice: 'Si su carga excede el peso permitido o es sobredimensionado, proporcione fotografías o más información de su carga.',
      cancel: 'Cancelar',
      send_request: 'Enviar solicitud',
      adviceOverweightTitle: 'Su envío tiene sobrepeso/sobredimensionado',
      adviceOverweightBody: 'Si está disponible, proporcione imágenes e información de su carga',
      adviceDGTitle: 'Su envío es mercancía peligrosa',
      adviceDGBody: 'Proporcione la descripción del producto y los documentos de respaldo',
      continue: 'Continuar cotizando'
    },
    newQuote: {
      departure_city: 'Origen',
      detination_city: 'Destino',
      calendar: 'Calendario',
      fe_per_kg: 'Tarifa por kilo',
      total_cost: 'Costo total',
      options: 'Tenemos {option} opciones para ti',
      noOptionsFCA: 'No hay opciones FCA',
      noOptions: 'No hay opciones',
      optionsFCA: 'Tenemos {option} opciones FCA para ti',
      optionsEXW: 'Tenemos {option} opciones EXW para ti',
      options_single: 'Tenemos {option} opción para ti',
      options_singleFCA: 'Tenemos {option} opción FCA para ti',
      options_singleEXW: 'Tenemos {option} opción EXW para ti',
      pickup: 'Recolección',
      flight: 'Vuelo',
      days: 'Días',
      day: 'Día',
      itinerary: 'Itinerario',
      air: 'Aérea',
      maritime: 'Marítima',
      carrier: 'Carrier',
      best_rate: 'Mejor Tarifa Disponible',
      total_consolidated: 'Total All In Consolidado',
      show_information: 'Ver más información',
      less_information: 'Menos información',
      expiration_at: 'Vigencia: '
    },
    alerts: {
      aforder_status_changed: 'El estatus de tu embarque cambio a {status}',
      aforder_remark_created: 'Nuevo comentario del equipo de logikoss',
      warning: 'Aviso',
      delete_user: '¿Estas seguro que deseas eliminar al usuario?'
    },
    tables: {
      perPage: 'Por página'
    },
    buttons: {
      home: 'Inicio',
      quote: 'Cotizar',
      search: 'Buscar',
      add: 'Crear',
      select: 'Seleccionar',
      cancel: 'Cancelar',
      view_itinerary: 'Ver itinerario y desglose',
      view_rate_breakdown: 'Ver desglose de tarifas',
      update: 'Confirmar',
      close: 'Cerrar',
      new_route: 'Nueva Ruta',
      use_logicoins: 'Usar Logikoins',
      logicoins_exchange: 'Canjear Logikoins',
      booking: 'Confirmar Reservación',
      back: 'Regresar',
      next: 'Siguiente',
      send_reset_link: 'ENVIAR LINK',
      save: 'Guardar',
      show_privacy: 'Aviso de privacidad',
      terms_and_conditions: 'Terminos y condiciones',
      preview_hawb: 'VISTA PREELIMINAR HAWB',
      preview_mawb: 'VISTA PREELIMINAR MAWB',
      history_quotations: 'HISTORIAL DE COTIZACIONES',
      requote: 'Volver a cotizar',
      expired: 'Vencida',
      select_route: 'Seleccionar Ruta',
      download_quote: 'DESCARGAR COTIZACIÓN',
      download_current_status: 'DESCARGAR ESTATUS ACTUAL',
      show_document: 'VER DOCUMENTO',
      edit_quote: 'Editar cotización',
      new_quote: 'Nueva cotización',
      special_quote: 'Cotización especial',
      no_option: 'Enviar información para una cotización especial',
      request_special_quote: 'Solicitar cotización',
      desktop: 'Escritorio',
      mobile: 'Movil',
      confirm: 'Si, confirmalo',
      confirmation: 'Confirmar',
      confirmDelete: 'Si bórralo!',
      confirmSend: 'Si, envíalo',
      accept: 'Aceptar',
      see: 'Ver',
      selectAnotherOption: 'Seleccionar otra opción',
      show_tracking: 'Seguimiento',
      clear_information: 'Limpiar formulario',
      view: 'Ver',
      edit: 'Editar',
      showTracking: 'Ver Tracking',
      copy: 'Copiar',
      file_upload: 'Seleccionar Archivos',
      goto_tracking: 'Ir al tracking'
    },
    titles: {
      login: 'Login',
      register: 'Regístrate',
      quotation: 'Realizar una cotización',
      quotation_found: 'Nuestras opciones para ti',
      pieces: 'Piezas',
      itinerary: 'Itinerario',
      rate_breakdown: 'Desglose de tarifas',
      frequencies: 'Frequencias',
      detail: 'Detalle',
      change_password: 'CAMBIAR CONTRASEÑA',
      logicoins_exchange: 'Logikoins a Cambiar',
      suppliersCreate: 'CREAR PROVEEDOR',
      suppliersEdit: 'ACTUALIZAR PROVEEDOR',
      usersEdit: 'ACTUALIZAR USUARIO',
      usersCreate: 'CREAR USUARIO',
      users: 'Usuarios',
      groups: 'Grupos',
      forgot_password: 'OLVIDASTE TU CONTRASEÑA',
      reset_password: 'RESTABLCER CONTRASEÑA',
      comments: 'Comentarios',
      terma_and_conditions: 'TÉRMINOS Y CONDICIONES',
      notify_of_privacy: 'AVISO DE PRIVACIDAD',
      date_pickup: 'FECHA DE PICK UP',
      flight_date: 'FECHA DE VUELO',
      old_bookings: 'Embarques antiguos',
      pickup: 'Fecha de Pickup',
      files: 'Documentos',
      remarks: 'Comentarios',
      special_quote: 'Cotización Especial',
      requoted: 'Recotización',
      expired: 'Cotización  Expirada',
      freight_types: 'Tipo de carga',
      special_quote_additional_info: 'Información adicional para la cotización especial',
      support: 'Contactos',
      suppliers: 'Proveedores',
      response: 'Respuesta',
      description: 'Descripción',
      success: 'Éxito!',
      booking_success: '¡Reservación exitosa!',
      specialCharges: 'Cargas especiales',
      active: 'Activo',
      downloadChat: 'Descargar Chat',
      yourWebHookHasBeenCreated: 'Tu webhook ha sido creado',
      serverError: 'Error del servidor, inténtelo de nuevo',
      atention: 'Atención',
      titleNotFoundInsurance: 'Tipo de carga no encontrado para Cotización de Seguro',
      descriptionNotFoundInsurance: 'Estimado cliente, su cotización de seguro requiere que alguien de nuestro personal de servicio al cliente se comunique con usted. Pronto será contactado.',
      physicalPerson: 'Persona fisica',
      moralPerson: 'Persona moral',
      titleOtherCountry: 'México no es origen o destino en cotización de seguro.',
      descriptionOtherCountry: 'Estimado cliente, su cotización de seguro requiere que alguien de nuestro personal de servicio al cliente se comunique con usted. Pronto será contactado.',
      titleValueMerchExceeded: 'Requerimiento de aprobación para seguro por Valor de la mercancía',
      descriptionValueMerchExceeded: 'Estimado cliente, su cotización de seguro requiere que alguien de nuestro personal de servicio al cliente se comunique con usted. Pronto será contactado.'
    },
    headers: {
      booking: 'Resumen',
      detailed_information: 'Información detallada',
      itinerary: {
        route: 'Ruta',
        flight: 'Vuelo',
        etd: 'ETD',
        eta: 'ETA',
        total: 'Total',
        subtotal: 'Subtotal',
        discount: 'Descuento',
        rate_with_discount: 'Tarifa con Descuento',
        rate: 'Tarifa',
        taxes: 'Impuestos',
        cw: 'Peso cargable',
        density_discount: 'Descuento por densidad',
        loose_discount: 'Descuento por carga suelta',
        flash_discount: 'Descuento relámpago'
      },
      quotation_option: {
        arrange: 'Ordenar por',
        transit: 'Tiempo en transito (días)',
        gross_weight: 'Peso bruto (kg)',
        chargeable_weight: 'Peso cargable (kg)',
        rate_per_kg: 'Tarifa por kg (USD/kg)',
        total: 'Total (USD)',
        cbm: 'CBM'
      },
      fee_breakdown: {
        text: 'El presupuesto incluye lo siguiente:',
        gross_weight: 'Peso bruto (kg)',
        volume_weight: 'Volumen cargable (kg)',
        chargeable_weight: 'Peso cargable (kg)',
        rate: 'Tarifa por kg (USD/kg)',
        subtotal: 'Subtotal (USD)',
        tax: 'Impuesto (USD)',
        total: 'Total (USD)',
        regular: 'Regular',
        discount: 'Descuento',
        total_discount: 'Total con descuento (USD)',
        final: 'Final'
      },
      frequency: {
        route: 'Ruta',
        flights: 'Vuelos',
        frequency: 'Frequencia',
        remark: 'Comentario'
      },
      logicoins: 'Logikoins canjeados',
      new_total: 'Nuevo Total',
      edit_supplier: 'Actualizar Proveedor',
      create_supplier: 'Agregar Nuevo Proveedor',
      edit_user: 'Actualizar Usuario',
      create_user: 'Agregar Nuevo Usuario',
      edit_fiscal_address: 'Actualizar Dirección Fiscal',
      create_fiscal_address: 'Agregar Dirección Fiscal',
      charge: 'Carga',
      filterSalesByStatus: 'Filtrar ventas por estado',
      markAsRead: 'Marcar como leído',
      booked: 'Reservada',
      selected: 'Seleccionada',
      no_selected: 'No Seleccionada',
      expired: 'Expirada',
      shipments: 'Embarques',
      money: 'Dinero',
      deleted: 'Eliminado!',
      error: 'Error!',
      active: 'Activa',
      create_group: 'Crear Grupo',
      edit_group: 'Editar Grupo',
      quote_saved: 'Tu cotización fue guardada con éxito',
      special_quotes: {
        revision: 'Revisión',
        process: 'Proceso',
        refused: 'Rechazado',
        see: 'Ver',
        expired: 'Expirado',
        cancelled: 'Cancelado',
        selected: 'Solicitada',
        sent: 'Enviada',
        rejected: 'Rechazada',
        booked: 'Reservada',
        approved: 'Aprobada'
      },
      my_quotations: {
        tab_quotations: 'Cotizaciones',
        tab_special_quotations: 'Cotizaciones especiales',
        tbl_gw: 'GW (kg)',
        tbl_validity: 'Vigencia',
        tbl_actions: 'Acciones'
      },
      preparingQuote: 'Muchas gracias por tu solicitud de cotización..',
      preparingQuoteText: 'Recibirás tu cotización por correo electrónico el día ',
      before8am: ' antes de las 8am.',
      sentInfo: 'Tu cotización fue enviada a ',
      contactInfo: ' en caso de que el correo requiera actualización, contacta a: '
    },
    menu: {
      dashboard: 'Inicio',
      quote: 'Cotizar',
      my_quotations: 'Mis cotizaciones',
      my_bookings: 'Mis embarques',
      my_old_bookings: 'Embarques antiguos',
      suppliers: 'Proveedores',
      users: 'Usuarios',
      groups: 'Grupos',
      blog: 'Blog',
      logikoins: 'Logikoins',
      financials: 'Pagos',
      support: 'Contactos',
      webhooks: 'Webhooks',
      active: 'Activo'
    },
    fields: {
      search: 'Buscar',
      actions: 'Acciones',
      login: {
        email: 'Email',
        password: 'Contraseña',
        rememberme: 'Recuérdame',
        forgot: '¿Olvidaste tu contraseña?',
        dont_account: '¿No tienes cuenta todavía?',
        register: 'Regístrate ahora',
        return: 'Regresar al sitio web',
        title: 'LGK Aéreo'
      },
      register: {
        text: 'Llena los siguientes campos para crear tu cuenta',
        full_name: 'Nombre completo',
        first_name: 'Nombre (s)',
        last_name: 'Apellidos',
        company: 'Compañía',
        phone: 'Teléfono',
        zone: 'Zona',
        email: 'Email',
        password: 'Contraseña',
        confirm_password: 'Confirma contraseña',
        button: 'CREAR CUENTA',
        have_account: '¿Ya tienes una cuenta?',
        sign_in: 'Inicia sesión'
      },
      header: {
        profile: 'Editar perfil',
        logikoins: 'Logikoins',
        support: 'Soporte',
        logout: 'Cerrar sesión',
        drawer: {
          notifications: 'Notificaciones',
          markAsRead: 'Marcar como leídas',
          all: 'Todas',
          unread: 'Sin leer | Sin leer ({count}) | Sin leer ({count})',
          read: 'Leídas | Leídas ({count}) | Leídas ({count})'
        },
        exchange_informative: 'Tipo de cambio informativo'
      },
      dashboard: {
        get_started: 'Empieza ya',
        quote: 'Cotizar',
        my_quotes: 'Mis cotizaciones',
        shipment_status: 'Embarques actuales',
        help_from: 'Ayuda de un representante',
        welcome: '¡Bienvenido,',
        latest_quotes: 'Últimas cotizaciones'
      },
      quotation: {
        origin: 'Origen',
        destination: 'Destino',
        pickup_date: 'Carga disponible',
        incoterm: 'Incoterm',
        number_pieces: 'Número de piezas',
        gw: 'GW',
        cbm: 'CBM',
        weight: 'Peso',
        weight_piece: 'Peso por pieza',
        length: 'Largo',
        width: 'Ancho',
        height: 'Altura',
        freight_type: 'Tipo de carga',
        pass_through_usa: 'Tránsito permitido por EEUU',
        pieces: 'Número de Piezas',
        code: 'Código',
        status: 'Estado',
        vw: 'VW',
        total: 'Total',
        date: 'Fecha de disponibilidad de carga',
        expired: 'Expira en (días)',
        action: 'Acción',
        chargeable_weight: 'Peso cargable',
        gross_weight: 'Peso de Carga (kg)',
        flights: 'Vuelos',
        frequency: 'Frecuencia',
        date_quote: 'Fecha de cotización',
        rate: 'Tarifa',
        type_of_measure: 'Cotizar por',
        dimensions: 'Pieza',
        volume: 'Volumen',
        route: 'Ruta',
        lowestPrice: 'Precio más bajo',
        fastestTransitTime: 'Tiempo de tránsito más rápido',
        system_conversion: 'Ingresa las dimensiones por pieza, el sistema convertirá automáticamente el volumen.',
        unity_m3: 'm3',
        unity_centimeters: 'Centimetros',
        unity_inches: 'Pulgadas',
        unity_kilograms: 'Kilogramos',
        unity_pounds: 'Libras',
        internal_reference_code: 'Código de referencia del cliente',
        internal_reference_code_placeholder: 'Ingresar código',
        pieces_placeholder: 'Ingresa el número de piezas',
        gross_weight_lb: 'GW (lb)',
        chargeable_weight_lb: 'Peso de carga (lb)',
        cargo_type_placeholder: 'Ingresa el tipo de carga',
        days: 'days'
      },
      insurance: {
        fiscal_address: 'Domicilio Fiscal',
        tax_id: 'RFC',
        placeholder_tax_id: 'Ingresa el RFC',
        country: 'País',
        placeholder_country: 'Ingresa el País',
        street: 'Calle, número ext. e int.',
        placeholder_street: 'Ingresa la calle',
        int: 'Número Int.',
        placeholder_int: 'Ingresa número int.',
        ext: 'Número Ext.',
        placeholder_ext: 'Ingresa número ext.',
        zipcode: 'C.P.',
        placeholder_zipcode: 'Ingresa el C.P.',
        state: 'Estado, Provincia, Región',
        placeholder_state: 'Ingresa el Estado, Provincia o Región',
        city: 'Localidad / Ciudad',
        placeholder_city: 'Ingresa la Localidad o Ciudad',
        municipality: 'Municipio / Alcaldía',
        placeholder_municipality: 'Ingresa el Municipio o Alcaldía',
        colony: 'Colonia',
        placeholder_colony: 'Ingresa la Colonia',
        flight_number: 'No. de vuelo',
        placeholder_flight_number: 'Ingresa el número de vuelo',
        invoice: 'No. de Factura de la mercancía',
        placeholder_invoice: 'Ingresa el número de factura',
        insurance: 'Seguro',
        name: 'Nombre del consignatario / Beneficiario',
        placeholder_name: 'Ingresa el nombre',
        origin: 'Origen',
        placeholder_origin: 'Ingresa el origen',
        destiny: 'Destino',
        placeholder_destiny: 'Ingresa el destino',
        typeBeneficiary: 'Tipo de beneficiario',
        carrier: 'Transportista',
        type: 'Tipo de carga',
        category: 'Categoría',
        placeholder_category: 'Selecciona la categoría',
        value: 'Valor de la mercancía (USD)',
        placeholder_value: '$',
        description: 'Descripción de la mercancía',
        placeholder_description: 'Ingresa la descripción',
        pieces: 'Piezas',
        placeholder_pieces: 'Ingresa el numero de piezas',
        gw: 'GW (kg)',
        cbm: 'CBM',
        chargable_weight: 'Peso de carga (kg)',
        weight: 'Peso (por pieza)',
        length: 'Largo',
        width: 'Ancho',
        height: 'Altura',
        placeholder_kg: 'kg',
        placeholder_m3: 'm3',
        placeholder_cm: 'cm',
        volume: 'Volumen',
        dimensions: 'Dimensiones (por pieza)',
        download_tc: 'Descargar términos y condiciones',
        quote: 'Cotizar',
        checkbox: 'No encuentro el tipo de carga en el listado',
        zipcode_checkbox: 'No pude encontrar el código postal en la lista',
        flight_date: 'Fecha de vuelo'
      },
      changePassword: {
        password: 'Contraseña',
        new_password: 'Nueva Contraseña',
        new_password_confirmed: 'Confirmación Nueva Contraseña'
      },
      suppliers: {
        tax_id: 'Tax ID',
        company_name: 'Nombre de la Empresa',
        address: 'Dirección',
        city: 'Ciudad',
        country: 'País',
        representative_name: 'Nombre Representativo',
        representative_phone: 'Teléfono representativo',
        representative_email: 'Correo Representativo',
        zip_code: 'Código Postal',
        client_id: 'ID Cliente',
        type: 'Tipo'
      },
      aforder: {
        code: 'Código de reserva',
        your_order: 'Número de órden:',
        commercial_reference: 'Código de embarque',
        status: 'Estatus',
        confirmation: 'Confirmación',
        authorization: 'Autorización',
        canceled: 'Cancelado',
        deadline: 'Fecha Fin',
        eta_warehouse: 'ETA Warehouse',
        mawb: 'MAWB',
        hawb: 'HAWB',
        eta: 'ETA',
        mawb_shipper_id: 'MAWB expedidor',
        mawb_consignee_id: 'MAWB consignatario',
        hawb_shipper_id: 'Expedidor',
        hawb_consignee_id: 'Consignatario',
        consolidated: 'Consolidado',
        picker: 'Recogedor',
        origin: 'Origen',
        destination: 'Destino',
        route: 'Ruta',
        incoterm: 'Incoterm',
        flight_date: 'Fecha de Vuelo',
        reserve_date: 'Fecha de Reservación',
        pieces: 'Piezas',
        weight: 'Peso',
        cbm: 'CBM',
        total_cost: 'Costo Total',
        type: 'Tipo',
        amount: 'Monto',
        write: 'Escribir..',
        date: 'Fecha',
        tracking: 'Tracking',
        progress: 'En proceso',
        finalized: 'Finalizado'
      },
      user: {
        avatar: 'Avatar',
        name: 'Nombre',
        email: 'Correo',
        password: 'Contraseña',
        confirm_password: 'Confirmar Contraseña',
        roles: 'Roles',
        update: 'Actualizado',
        groups: 'Grupos',
        change_image: 'Cambiar imagen'
      },
      client: {
        invoicing: {
          days: 'Días',
          day: 'Día',
          documents: 'Documentos incluidos en email',
          fiscal_information: 'Información Fiscal',
          cfdi_use: 'Uso CFDI',
          payment_method: 'Método de Pago'
        }
      },
      webhooks: {
        name: 'Nombre',
        event: 'Evento',
        uri: 'Uri',
        api_token: 'Api Token',
        total_requests: 'Peticiones',
        method: 'Método',
        request_data: 'Datos de Solicitud',
        response_data: 'Datos de Respuesta',
        response_status_code: 'Codigo de Respuesta',
        date: 'Fecha'
      },
      forgotPassword: {
        email: 'Correo'
      },
      invoicing: {
        folio: 'Referencia cliente',
        currency: 'Moneda',
        status: 'Estatus',
        doc_date: 'Fecha Doc',
        due_date: 'Fecha Due',
        payment_date: 'Fecha de Pago',
        cancellation_date: 'Fecha de Cancelación',
        subtotal: 'Subtotal',
        total: 'Total',
        pending_balance: 'Balance Pendiente'
      },
      logikoins: {
        title: '¿Qué son los Logikoins?',
        paragraph1: 'Son monedas virtuales que vas a poder utilizar para pagar embarques.',
        paragraph2: 'Para obtenerlos sólo necesitas hacer lo que haces, porque cada embarque que transportes con nosotros obtendrás Logikoins.',
        paragraph3: 'Por eso mientras más embarques muevas, más Logikoins vas a tener.',
        title_levels: 'Niveles',
        levels_paragraph: 'Estamos buscando tener una mejor relación contigo reconociendo tu lealtad. Tenemos 4 diferentes niveles que podrás alcanzar dependiendo de los movimientos que hagas con nosotros. En cada nivel tendrás acceso a tarifas preferenciales y espacios exclusivos.',
        amount: 'Monto',
        description: 'Descripción',
        date: 'Fecha',
        information: 'There is no information',
        zeppelin: '1. Zeppelin',
        zeppelin_text: '¡Bienvenido! Acabas de emprender el viaje en nuestra plataforma. Al ser cliente nuevo, te regalamos 10 Logikoins que podrás canjear en tus nuevos embarques. Sigue realiando reservaciones para subir de nivel.',
        plane: '2. Avioneta',
        plane_text: 'Obtienes este nivel acumulando 10 embarques o $30,000 USD en un periodo de 6 meses, lo que pase primero. Para mantener este nivel tendrás que seguir con las mismas operaciones durante el siguiente periodo de 6 meses.',
        jet: '3. Jet',
        jet_text: 'Obtienes este nivel acumulando 20 embarques o $60,000 USD en un periodo de 6 meses, lo que pase primero. Para mantener este nivel tendrás que seguir con las mismas operaciones durante el siguiente periodo de 6 meses.',
        space_ship: '4. Nave Espacial',
        space_ship_text: 'Obtienes este nivel acumulando 40 embarques o $120,000 USD en un periodo de 6 meses, lo que pase primero. Para mantener este nivel tendrás que seguir con las mismas operaciones durante el siguiente periodo de 6 meses.',
        current_level: 'Nivel actual',
        zeppelin_name: 'Zeppelin',
        plane_name: 'Avioneta',
        jet_name: 'Jet',
        space_ship_name: 'Nave Espacial',
        commercial_reference: 'Código Cliente'
      },
      notifications: {
        status: 'Estatus',
        title: 'Título',
        text: 'Texto',
        read_at: 'Leído el'
      },
      booking: {
        title: 'Reservación',
        quote: 'Cotización',
        route: 'Ruta',
        quotation_code: 'Código de cotización',
        transit_time: 'Tiempo en tránsito total',
        transit_time_day: '0 días | 1 día | {count} días',
        air: 'Vuelo',
        legend: 'Recuerda el tiempo para que expire tu cotización es de: {days_to_expire} días',
        itinerary: 'Itinerario',
        flight: 'Vuelo',
        rate_breakdown: 'Desglose de Tarifas',
        legend_rate_breakdown: 'La tarifa incluye: ',
        exchange_logikoins: 'Cambia Logikoins',
        max_logikoins_to_use: 'Uso máximo de logikoins: ',
        first_remark: 'El descuento por volumen sólo es válido para las dimensiones y pesos ingresados',
        logikoins_to_use: 'Uso máximo de logikoins: {logikoins}'
      },
      show_aforder: {
        discount: 'Descuento',
        summary: 'Resumen',
        origin: 'ORIGEN:',
        destination: 'DESTINO:',
        route: 'RUTA:',
        pickup_date: 'FECHA PICKUP:',
        estimated_departure: 'SALIDA ESTIMADA:',
        estimated_arrival: 'LLEGADA ESTIMADA:',
        transit_time: 'TIEMPO EN TRANSITO:',
        cargo: 'Carga',
        number_of_pieces: '# DE PIEZAS:',
        gross_weight: 'PESO BRUTO (kg):',
        volume_weight: 'PESO VOLUMETRICO (kg):',
        cbm: 'CBM',
        chargeable_weight: 'PESO TARIFADO (kg):',
        type: 'TIPO',
        length: 'LARGO',
        width: 'ANCHO',
        height: 'ALTO',
        weight: 'PESO',
        charges: 'Cargos',
        total: 'TOTAL:',
        rate: 'TARIFA:',
        chargeable_weight_charges: 'PESO TARIFADO:',
        comments: 'COMENTARIOS',
        no_comments: 'No hay comentarios registrados',
        message: 'Mensaje',
        legend_comments: 'Escribe aquí tu mensaje, el área de operaciones te responderá en breve',
        status_history: 'Historial de Estatus',
        documents: 'Documentos',
        itinerary: 'Itinerario',
        direct_awb: 'Directo AWB',
        mawb_consignee: 'CONSIGNATARIO MAWB',
        hawb_consignee: 'CONSIGNATARIO HAWB',
        hawb_shipper: 'EXPEDIDOR HAWB',
        shipment_details: 'Detalles del Embarque',
        flight_date: 'FECHA DE VUELO:',
        flight: 'VUELO:',
        selling_date: 'FECHA DE VENTA:',
        payment_options_on_the_hawb: 'OPCIONES DE PAGO EN EL HAWB:',
        available: 'DISPONIBLE:',
        deadline: 'FECHA LÍMITE:',
        authorization: 'AUTORIZACIÓN:'
      },
      status_history: {
        status: 'Estatus',
        date: 'Fecha',
        by: 'Por'
      },
      documents: {
        name: 'Nombre',
        type: 'Tipo',
        actions: 'Acciones'
      },
      itinerary: {
        origin: 'Origen',
        destination: 'Destino',
        number: 'Número',
        pieces: 'Piezas'
      },
      history_quotations: {
        title: 'HISTORIAL DE COTIZACIONES',
        code: 'Código',
        pieces: 'Piezas',
        volume_weight: 'Peso Volumétrico',
        gross_weight: 'Peso Bruto',
        cbm: 'CBM',
        chargeable_weight: 'Peso cargable',
        type: 'Tipo de carga',
        transit_usa: 'Tránsito a través de EE. UU. permitido',
        rate: 'Tarifa',
        total_sale: 'Total',
        created_at: 'Creado Por',
        unit: 'Unidad',
        comments: 'Comentarios',
        quantity: 'Cantidad',
        retained_taxes: 'Impuestos Retenidos',
        transferred_taxes: 'Impuestos Transferidos',
        subtotal: 'Subtotal',
        total: 'Total',
        total_usd: 'Total USD'
      },
      old_bookings: {
        gross_weight: 'Peso Bruto (kg)',
        volume_weight: 'Peso Volumetrico (kg)',
        chargeable_weight: 'Peso Tarifado (kg)',
        mawb_shipper: 'EXPEDIDOR MAWB',
        deliveries: {
          title: 'Entregas',
          truck: 'Camión',
          quantity: 'Cantidad',
          operator: 'Operador'
        },
        sales: {
          title: 'Venta',
          currency: 'Moneda',
          type: 'Tipo',
          exchange_rate: 'Tipo de Cambio',
          comments: 'Comentarios',
          sale_concept: 'Concepto de Venta',
          quantity: 'Cantidad',
          rate: 'Tarifa',
          unit: 'Unidad',
          transferred_taxes: 'Impuestos Transferidos',
          retained_taxes: 'Impuestos Retenidos',
          subtotal: 'Subtotal',
          total: 'Total'
        }
      },
      blog: {
        air_import: {
          title: 'Manua de Ventas Importación Aérea',
          text: 'Una pregunta común de los agentes de carga es ¿Qué tarifa debo ofrecer a mi cliente? La respuesta debe considerar varios factores como:',
          first: 'Tipo de carga de producto',
          second: 'Tipo de industria',
          third: 'Tamaño de la empresa',
          text2: 'Como parte de nuestro compromiso con los agentes de carga realizamos un estudio para responder a esta pregunta básica. Descarga el siguiente documento para conocer más.'
        },
        how_quote: {
          title: '¿Cómo cotizar?',
          text: '¿Tienes alguna duda para cotizar? Sigue estos sencillos pasos y obten increíbles cotizaciones.'
        }
      },
      financials: {
        invoicing: {
          title: 'FACTURACIÓN',
          summary: 'Resumen',
          fiscal_address: 'Direcciones Fiscales'
        },
        billing_information: {
          title: 'DATOS DE FACTURACIÓN',
          subtitle: 'Datos de Facturación',
          cfdi_use: 'Uso CFDI : ',
          payment_method: 'Método de Pago: ',
          documents: 'Documentos: ',
          fiscal_information: 'Información Fiscal: ',
          periodicity: 'Periodicidad: '
        },
        bank_accounts: {
          title: 'CUENTAS BANCARIAS',
          subtitle: 'Cuentas Bancarias',
          company_information: 'Datos de la empresa ',
          business_name: 'Razón Social: ',
          rfc: 'Registro Federal de Contribuyentes: ',
          fiscal_address: 'Domicilio Fiscal: ',
          phone: 'Teléfono: ',
          email: 'Correo electrónico: ',
          contact: 'Contacto: ',
          freight_payment: 'PAGO FLETE',
          bank: 'Banco: ',
          beneficiary: 'Beneficiario: ',
          account_number: 'Número de Cuenta: ',
          branch_name: 'Nombre de la Sucursal: ',
          branch_number: 'Número de Sucursal: ',
          bank_located: 'Estado o ciudad donde se encuentra el banco: ',
          clabe_interbank: 'CLABE interbancaria: ',
          currency: 'Moneda: ',
          payment_reva: 'PAGO REVALIDACIÓN'
        }
      },
      special_quote: {
        origin_country: 'País de origen',
        origin_region: 'Región de origen',
        origin_city: 'Ciudad de origen',
        destination_country: 'País de destino',
        destination_region: 'Región de destino',
        destination_city: 'Ciudad de destino',
        zip_code: 'Código Postal',
        deadline: 'Vigencia',
        nature_charge: 'Naturaleza de la Carga',
        pickup_date: 'Disponible a partir de',
        address: 'Dirección',
        pickup_address: 'Dirección de recolección',
        pickup_address_placeholder: 'Ingresar dirección de recolección',
        other_freight_type: 'Otro',
        destination_airport: 'Aeropuerto de destino',
        origin_airport: 'Aeropuerto de origen',
        available_date: 'Fecha de carga disponible',
        available_date_provided: 'Fecha de carga lista proporcionada',
        available_date_not_provided: 'Aún no cuento con mi fecha de carga disponible',
        available_date_not_provided_warning: 'Se otorgan tarifas considerando la tarifa disponible al momento, sujeto a validez y cambio cuando la carga esté disponible.',
        service: 'Tipo de carga',
        contains_batteries: '¿Contiene baterías de litio?',
        commodity: 'Descripción del producto',
        service_warning: 'Para carga DG, proveer con MSDS actualizado y para China Continental (Mainland China), deberá contarse con certificado SRICI/PONY o certificado validado por una organización certificadora China, los MSDS NO serán válidos en China al momento de generar el booking.',
        services_options: {
          general_cargo_stackable: 'Carga General / Apilable',
          general_cargo_no_stackable: 'Carga General / No Apilable',
          overweight_oversized: 'Sobrepeso / Sobredimensionado',
          dangerous_goods: 'Mercancías Peligrosas',
          perishable: 'Perecedera'
        },
        batteries_options: {
          no_batteries: 'Sin baterías',
          lithium_ion: 'ELI - UN3481 - Baterías de ion de litio - Sección II',
          lithium_metal: 'ELM - UN3091 - Baterías de metal de litio - Sección II',
          combination: 'UN3481/UN3091 - combinación - Sección II'
        },
        deadline_arrival: 'Deadline de arribo',
        internal_reference: 'Código de referencia interna'
      },
      remarks: {
        remark: 'Comentario',
        enter_remark: 'Ingresa tu comentario'
      },
      file: {
        type: 'Tipo',
        file: 'Archivo',
        comments: 'Comentarios',
        attach_file: 'Adjuntar documentos'
      },
      support: {
        contact_title: 'Datos de contacto',
        text: 'Contáctanos si tienes alguna duda.',
        phone: 'Teléfono',
        title_quotation_question: '¿Tienes alguna duda para cotizar?',
        text_quotation_question: 'Sigue estos sencillos pasos y obten increíbles cotizaciones.',
        show_document: 'Ver documento'
      },
      mega_sale_status: {
        all: 'TODAS',
        paid: 'PAGADAS',
        pending: 'PENDIENTES',
        canceled: 'CANCELADAS',
        cancellation: 'CANCELACION EN PROCESO',
        partial_paid: 'PAGADAS PARCIALMENTE'
      },
      address: {
        legal_name: 'Nombre Legal',
        tax_id: 'RFC',
        city: 'Ciudad',
        street: 'Calle',
        no_ext: ' No. Ext.',
        colony: 'Colonia',
        municipality: 'Municipio',
        state: 'Estado',
        zip_code: 'C.P',
        country: 'País',
        no_int: 'No. Int.',
        alias: 'Alias',
        responsable: 'Responsable',
        reference: 'Referencias',
        locality: 'Localidad',
        alias_placeholder: 'Dato para identificar la dirección.'
      },
      group: {
        name: 'Nombre',
        users: 'Usuarios'
      }
    },
    messages: {
      question_contact: '¿Tienes alguna duda para cotizar?',
      text_contact: 'Contacta a nuestros asesores',
      login_header: 'Complete sus siguientes datos a continuación para iniciar sesión.',
      quotation_option: 'En estos momentos no contamos con alguna opción para este trayecto por favor intenta con una nueva ruta',
      login_session: 'Complete los siguientes datos para iniciar sesión.',
      change_password: 'Si tú quieres usar esta aplicación necesitas cambiar tu contraseña',
      password_changed: 'Es necesario volver a iniciar sesión siempre que la contraseña haya sido modificada',
      session_expired: 'Su contraseña ha expirado, es necesario volver a iniciar sesión para cambiarla',
      logicoins_to_use: 'Puedes usar {logicoins_to_use} logikoins',
      gain_logicoins: 'Reserva ahora y obtén {gain_logicoins} Logikoins',
      forgot_password: 'Si olvidaste tu contraseña es necesario que la restablezcas, escribe tu email a continuación y recibirás un correo para realizar esta acción',
      reset_password: 'Para restablecer tu contraseña es necesario llenar el siguiente formulario',
      expire_days: 'Tiempo restante para que expire tu cotización: {expire_days} días',
      direct_awb: 'Para usar el llenado automático, completa la información en esta liga:',
      disclaimer_oldbooking: 'Estimado cliente, bienvenido a la nueva plataforma logikoss.com.\n' + 'Los detalles de los envíos reservados en la versión anterior se pueden encontrar aquí.',
      membership_next_level: 'Si subieras a la categoría {next_membership} estarías pagando por este embarque',
      saving_money: 'ahorrando {saving_money} USD',
      empty_remarks: 'No hay comentarios registrados.',
      placeholder_comment: 'Escriba su mensaje aquí, nuestro equipo de operaciones responderá tan pronto sea posible.',
      booked: 'Esta cotización ya fue reservada',
      under_authorization: 'Esta cotización esta esperando ser aprobada',
      options: 'Tenemos {option} opciones para ti',
      noOptionsFCA: 'No hay opciones FCA',
      optionsFCA: 'Tenemos {option} opciones FCA para ti',
      optionsEXW: 'Tenemos {option} opciones EXW para ti',
      options_single: 'Tenemos {option} opción para ti',
      options_singleFCA: 'Tenemos {option} opción FCA para ti',
      options_singleEXW: 'Tenemos {option} opción EXW para ti',
      discount_availability: 'Descuento sujeto a disponibilidad',
      booking_before: 'Reserva antes de:',
      tooltipCreateWebhook: 'Crear Webhook',
      tooltipEdit: 'Editar',
      tooltipDelete: 'Eliminar',
      tooltipWebhookCredentials: 'Credenciales Webhook',
      aforderStatusChanged: 'Notificación cuando hay un cambio de estado de algún embarque',
      aforderWeightsUpdated: 'Notificación cuando hay una actualización de pesos de algún embarque',
      aforderItineraryUpdated: 'Notificación cuando hay un cambio de itinerario de algún embarque',
      aforderQuotationSalesUpdated: 'Notificación cuando hay una actualización en la cotización de una venta',
      aforderUploadFile: 'Notificación cuando se agrego un documento de algún embarque',
      aforderUpdated: 'Notificación cuando hay una actualización de algún embarque',
      aforderAuthorized: 'Notificación cuando algún embarque es autorizado',
      aforderDeliveryUpdated: 'Notificación cuando hay una actualización de entrega de algún embarque',
      requoted: 'Tu cotización ha sido recotizada debido a su fecha de expiración',
      expired: 'Su cotización ha expirado. Vuelva a citarlo para obtener nuevas tarifas.',
      thisQuotationHasBeenSavedWithCode: 'Esta cotización ha sido guardada con el código',
      itWillBeValidFor: 'Será válido para',
      areYouSure: '¿Esta usted seguro?',
      confirmBookingText1: 'La ruta seleccionada utiliza vuelos de pasajeros. Asegúrese de que las dimensiones máximas por pieza sean',
      bookingConfirmedText1: 'Este envío ha sido reservado bajo el código:',
      bookingConfirmedText2: 'Puedes seguir sus actualizaciones en el tracking',
      stpRemark: 'Si la carga contiene: Equipo de audio y sonido, equipo eléctrico, electrodomésticos o motores, pueden aplicar costos extra por hasta',
      allRightsReserved: 'Todos los derechos reservados',
      nextLevelShipments: 'Llevas {current} embarques, solo necesitas {missing} embarques para alcanzar el siguiente nivel',
      nextLevelAmount: 'Llevas {current} USD, solo te faltan {missing} USD para llegar al siguiente nivel',
      dataHasBeenDeleted: 'Los datos han sido eliminados.',
      dataHasNotBeenDeleted: 'Los datos no han sido eliminados.',
      youWontBeAbleToRevertThis: 'No podrás revertir esto',
      noOptions: 'No hay opciones para su cotización',
      stpSend: 'Su cotización especial ha sido enviada',
      noSTPSaved: 'No se ha guardado ninguna cotización',
      quoteSaved: 'Su cotización ha sido guardada',
      whichGroupQuoteAssigned: '¿A qué grupo se asignará esta cotización?',
      firstSelectDateItineray: 'Primero debe escoger una fecha del itinerario',
      quoteHasBeenSentForAuth: 'La cotización ha sido enviada para autorización.',
      defaultAirportError: 'Contacte al administrador para validar el origen.'
    },
    countries: {
      mexico: 'México',
      colombia: 'Colombia',
      ecuador: 'Ecuador',
      chile: 'Chile',
      brasil: 'Brasil'
    },
    support: {
      sales_director: 'Director de Ventas',
      commercial_director: 'Directora Comercial',
      general_manager: 'Gerente General',
      bussiness_development: 'Desarrollo de Negocios'
    },
    screnNewQuotation: {
      departure_city: 'Ciudad de Origen',
      detination_city: 'Ciudad de Destino',
      quote_edit: 'Editar',
      new_quote: 'Nueva cotización',
      pieces: 'Piezas',
      gross_weight: 'Peso bruto (kg)',
      cbm: 'CBM (m3)',
      loadable_weight: 'Peso Cargable (kg)',
      density: 'Densidad (kg/CBM)',
      download_quotation: 'Descargar cotización',
      searchResult: 'Los resultados de tu búsqueda',
      options: 'Tenemos <span style="font-weight: 500">{option}</span> opciones para ti',
      noOptionsFCA: 'No hay opciones FCA',
      noOptionsEX: 'No hay opciones EX',
      optionsFCA: 'Tenemos <span style="font-weight: 500">{option}</span> opciones FCA para ti',
      optionsEXW: 'Tenemos <span style="font-weight: 700">{option}</span> opciones EXW para ti',
      options_single: 'Tenemos <span style="font-weight: 500">{option}</span> opción para ti',
      options_singleFCA: 'Tenemos <span style="font-weight: 500">{option}</span> opción FCA para ti',
      options_singleEXW: 'Tenemos <span style="font-weight: 700">{option}</span> opción EXW para ti',
      flightDate: 'Fecha de vuelo',
      quotation_option: 'En estos momentos no contamos con alguna opción para este trayecto por favor intenta con una nueva ruta',
      consolidation: 'Consolidado',
      route: 'Ruta',
      airline: 'Aerolínea',
      discount_density: 'DESCUENTO POR DENSIDAD',
      discount_density_detail: 'Valido para detalles, fecha y ruta descrita, MAWB consignada a Logikoss',
      volume_discount: 'DESCUENTO VOLUMÉTRICO',
      volume_discount_detail: 'Descuento para carga volumétrica aplica para los detalles especificados y consignada a Logikoss',
      consolidation_discount: 'BENEFICIO DE CONSOLIDACIÓN',
      loose_charge: 'DESCUENTO POR CARGA DENSA',
      capacity: 'Capacidad Total',
      available_capacity: 'Capacidad Disponible',
      pickup: 'Recolección',
      more_information: 'Mostrar información',
      table: {
        rate: 'Tarifa',
        cost: 'Total',
        normal: 'Normal',
        discount: 'Descuento',
        final: 'Final'
      },
      remark_consolidation: 'Beneficio de consolidación válido para detalles, fecha y ruta descrita, MAWB consignada a Logikoss.'
    },
    newTrackingPresentation: {
      selectAnOrderNumber: 'Selecciona un número de orden',
      noDataAvailable: 'No hay datos disponibles',
      cargoHistory: `Historial`,
      cargoArrived: 'Su carga llega el',
      origin: 'Origen',
      destination: 'Destino',
      shipmentDetails: 'Detalles de la carga',
      incoterm: 'Incoterm',
      weight: 'Peso',
      chargeableWeight: 'Peso Cargable (kg)',
      density: 'Densidad',
      pieces: 'Piezas',
      remark: 'Los detalles de la carga son diferentes a los que aparecen al reservar el envío',
      viewDetails: 'Ver historial',
      cargoDetailHistory: 'Historial de itinerario',
      dateWhenChangeWasMade: 'Fecha en la que se realizó el cambio',
      comments: 'Comentarios',
      backToCurrentSchudule: 'Volver al itinerario actual',
      noChangesYet: 'Aún no hay cambios',
      galleryMedia: 'Galería de medios',
      schedule: 'Itinerario',
      shareTracking: 'Compartir rastreo',
      shareTrackingByEmail: 'Compartir embarque por correo electrónico',
      sendByEmail: 'Enviar por correo electrónico',
      downloadPDF: 'Descargar PDF',
      scheduleHistory: 'Historial de horarios',
      scheduleBottomText: 'Este horario es diferente al reservado',
      ps: 'PZAS',
      kg: 'Kg',
      fn: 'Vuelo/Truck',
      sheduleDivider: 'Carga dividida: La carga ha sido dividida en las siguientes rutas',
      sendByWhatsapp: 'Enviar por Whatsapp',
      sendWhatsappMessage: 'Enviar mensaje de Whatsapp',
      send: 'Enviar',
      client: 'Cliente',
      whatsappMessage: 'En el PDF podrás encontrar el status actual del embarque',
      download: 'Descargar',
      itsEmpty: 'Está vacío',
      of: 'de',
      cargoOnBoard: 'Carga confirmada a bordo',
      cargoNoOnBoard: 'Carga no confirmada a bordo',
      messageP1: 'Estimado cliente:',
      messageP2: 'Recibe adjunto el tracking de tu embarque:',
      messageP3: 'Con las siguientes características:',
      subject: 'Asunto',
      to: 'Para',
      lastSystemUpdate: 'Última actualización del sistema',
      withoutItineraryCargoNotReady: 'Sin itinerario, carga no lista'
    },
    insurance: {
      modal: {
        title: 'Cotizar seguro de embarque',
        title2: 'Confirmar seguro de embarque',
        title3: 'Póliza de seguro',
        title4: 'Cotización seguro de embarque',
        subtitle: 'Seguro de Embarque',
        subtitle2: 'Tu seguro fue contratado con éxito',
        subtitle3: 'Tu cotización de seguro fue guardada con éxito',
        text1: 'Cobertura del seguro de embarque:',
        text2: 'Ahora puedes ver tus Seguros cotizados en  Mis cotizaciones',
        step1: 'Cotización',
        step2: 'Contratación',
        step3: 'Confirmación',
        here: 'Aquí',
        tc: 'Términos y condiciones',
        download_tc: 'Descarga los término y condiciones',
        download_insurance: 'Descarga tu póliza de seguro',
        title_alert: 'Confirmar seguro',
        message_alert: '¿Estas seguro que deseas confirmar la compra del seguro de tu embarque?',
        continue: 'Continuar cotizando',
        btn_continue: 'Continuar',
        btn_save: 'Guardar',
        btn_cancel: 'Cancelar',
        btn_back: 'Atras',
        btn_hire: 'Contratar',
        btn_confirm: 'Confirmar',
        btn_create: 'Crear Usuario',
        go_to_insurance: 'Ir a mis seguros cotizados',
        go_to_hire: 'Ir a mis seguros contratados',
        bnt_finish: 'Finalizar',
        disclaimer: 'ACLARACION: LOS TERMINOS QUE APARACEN EN EL IDIOMA INGLES Y QUE SON MENCIONADOS DENTRO DE ESTE MODULO DE SEGUROS PARA COTIZACION Y EMISION DEL CERTIFICADO DE SEGUROS Y/O CUALQUIER DOCUMENTO Y/O PROCESO RELACIONADO A LOS TEMAS DE SEGUROS ES UNA TRADUCCION LIBRE Y DE CORTESIA AL INGLES, POR LO QUE SIEMPRE PARA CUALQUIER DISCREPANCIA Y OBSERVACION QUE PUDIERA EXISTIR, SIEMPRE PREVALECERA LA VERSION DEL IDIOMA EN ESPAÑOL, YA QUE ES UNA TRADUCCION ORIGINAL DEL ESPAÑOL.'
      },
      quoteTable: {
        tab: 'Cotización de seguro',
        noQuote: 'No. de cotización',
        origin: 'Origen',
        destiny: 'Destino',
        value: 'Valor mercancia (USD)',
        total: 'Total seguro',
        expires: 'Expira en',
        tyc: 'Términos y condiciones',
        action: 'Acción',
        download: 'Descargar',
        confirm: 'Confirmar'
      },
      bookingTable: {
        tab: 'Seguros contratados',
        tabAforder: 'Reservaciones actuales',
        noQuote: 'No. de cotización',
        noPolicy: 'No. Certificado',
        origin: 'Origen',
        destiny: 'Destino',
        value: 'Valor de la mercancía',
        date: 'Fecha de reservación',
        insuranceCarrier: 'Aseguradora',
        codeClient: 'Codigo de cliente',
        actions: 'Guía de Daños'
      },
      general: {
        quote: 'Cotizar seguro',
        insuranceHired: 'Seguro contratado',
        insuranceQuoted: 'Seguro cotizado'
      }
    }
  },
  pt: {
    unique_quote: {
      button_ok: 'Aceitar',
      contains_batteries: 'Contém baterias de lítio?',
      contains_batteries_placeholder: 'Selecione',
      commodity: 'Descrição do produto',
      commodity_placeholder: 'Insira a descrição',
      quotation_tab: 'Cotar carga',
      insurance_tab: 'Cotar seguro',
      general_information: 'Informações gerais',
      origin_placeholder: 'Inserir a origem',
      destination_placeholder: 'Inserir o destino',
      available_on_placeholder: 'yyyy/mm/dd',
      incoterm_placeholder: 'Insira o incoterm',
      cargo_type: 'Tipo de carga',
      pass_via_usa: 'Trânsito permitido pelos EUA',
      rules: {
        gw_total: 'Valor mínimo permitido {min} ',
        density: 'A densidade deve estar entre {min} e {max} ',
        max_value: 'Valor máximo permitido {max} '
      },
      modalSpecialQuoteTitle: 'As características de sua carga ultrapassam limites pré-estabelecidos',
      modalSpecialQuoteNotDetails: 'Fornecer os detalhes dependendo da sua carga.',
      modalSpecialQuoteBody: 'Forneça informações adicionais para que possamos preparar um orçamento personalizado para sua solicitação.',
      origin_airport: 'Aeroporto de origem',
      gw: 'GW',
      vw: 'VW',
      cw: 'CW',
      volume: 'Volume',
      density: 'Densidade',
      pure_batteries: 'Baterias puras não são permitidas',
      remark_placeholder: 'Insira seus comentários',
      file_placeholder: 'Fotografias ou mais informações',
      file_advice: 'Se sua carga exceder o peso permitido ou é superdimensionada, forneça fotografias ou mais informações de sua carga',
      cancel: 'Cancelar',
      send_request: 'Enviar solicitação',
      adviceOverweightTitle: 'Sua remessa está acima do peso/dimensionada',
      adviceOverweightBody: 'Se disponível, forneça imagens e informações da sua carga',
      adviceDGTitle: 'Sua remessa é de mercadorias perigosas',
      adviceDGBody: 'Forneça a descrição do produto e documentos de apoio',
      continue: 'Continuar citando'
    },
    newQuote: {
      departure_city: 'Origem',
      detination_city: 'Destino',
      calendar: 'Calendário',
      fe_per_kg: 'Taxa por quilo',
      total_cost: 'Custo total',
      options: 'Temos {option} opções para você',
      noOptionsFCA: 'Não há opções de FCA',
      noOptions: 'Não há opções',
      optionsFCA: 'Temos {option} opções FCA para você',
      optionsEXW: 'Temos {option} opções EXW para você',
      options_single: 'Temos {option} opção para você',
      options_singleFCA: 'Temos {option} opção FCA para você',
      options_singleEXW: 'Temos {option} opção EXW para você',
      flight: 'Voo',
      pickup: 'Coleta',
      days: 'Dias',
      day: 'Dia',
      itinerary: 'Itinerário',
      air: 'Ar',
      maritime: 'Marítimo',
      carrier: 'Carrier',
      best_rate: 'Melhor Tarifa Disponível',
      total_consolidated: 'Total All In Consolidados',
      show_information: 'Mostrar informações',
      less_information: 'Menos informações',
      expiration_at: 'Prazo para reservas'
    },
    alerts: {
      aforder_status_changed: 'O status de seu embarque mudou para {status}',
      aforder_remark_created: 'Novo comentário da equipe da logikoss',
      warning: 'Aviso',
      delete_user: 'Tem a certeza de que pretende eliminar o utilizador?'
    },
    tables: {
      perPage: 'Por página'
    },
    buttons: {
      home: 'Início',
      quote: 'Cotar',
      search: 'Pesquisar',
      add: 'Criar',
      select: 'Seleccionar',
      cancel: 'Cancelar',
      view_itinerary: 'Ver itinerário e divisão',
      view_rate_breakdown: 'Ver discriminaҪão  de tarifas',
      update: 'Confirmar',
      close: 'Fechar',
      new_route: 'Nova Rota',
      use_logicoins: 'Usar Logikoins',
      logicoins_exchange: 'Trocar Logikoins',
      booking: 'Confirmar Reserva',
      back: 'Voltar',
      next: 'Seguinte',
      send_reset_link: 'ENVIAR LINK',
      save: 'Salvar',
      show_privacy: 'Aviso de privacidade',
      terms_and_conditions: 'Termos e condições',
      preview_hawb: 'VISTA PRELIMINAR HAWB',
      preview_mawb: 'VISTA PRELIMINAR MAWB',
      history_quotations: 'HISTÓRICO DE COTAҪÕES',
      requote: 'Cotar novamente',
      expired: 'Vencida',
      select_route: 'Selecionar Rota',
      download_quote: 'BAIXAR COTAÇÃO',
      download_current_status: 'BAIXAR STATUS ATUAL',
      show_document: 'VER DOCUMENTO',
      edit_quote: 'Editar cotação',
      new_quote: 'Nova cotação',
      special_quote: 'Cotação especial',
      no_option: 'Enviar informações para uma cotação especial',
      request_special_quote: 'Solicitar cotação',
      desktop: 'Desktop',
      mobile: 'Móvel',
      confirm: 'Sim, confirme',
      confirmation: 'Confirmar',
      confirmDelete: 'Sim, apague!',
      confirmSend: 'Sim envie',
      accept: 'Aceitar',
      see: 'Ver',
      selectAnotherOption: 'Selecione outra opção',
      show_tracking: 'Monitorando',
      clear_information: 'Informação limpa',
      view: 'Ver',
      edit: 'Editar',
      showTracking: 'Ver tracking',
      copy: 'Copie',
      file_upload: 'Selecionar Arquivos',
      goto_tracking: 'Ir para tracking'
    },
    titles: {
      login: 'Login',
      register: 'Cadastre-se',
      quotation: 'Fazer uma cotação',
      quotation_found: 'Nossas opções para você',
      pieces: 'Peças',
      itinerary: 'Itinerário',
      rate_breakdown: 'Discriminação de tarifas',
      frequencies: 'Frequências',
      detail: 'Detalhe',
      change_password: 'MUDAR SENHA',
      logicoins_exchange: 'Logikoins para Trocar',
      suppliersCreate: 'CRIAR FORNECEDOR',
      suppliersEdit: 'ATUALIZAR FORNECEDOR',
      usersEdit: 'ATUALIZAR USUÁRIO',
      usersCreate: 'CRIAR USUÁRIO',
      users: 'Usuários',
      groups: 'Grupos',
      forgot_password: 'VOCÊ ESQUECEU SUA SENHA',
      reset_password: 'RESTAURAR SENHA',
      comments: 'Comentários',
      terma_and_conditions: 'Termos e Condições',
      notify_of_privacy: 'AVISO DE PRIVACIDADE',
      date_pickup: 'DATA DE RETIRADA',
      flight_date: 'DATA DO VOO',
      old_bookings: 'Reservas Antigas',
      pickup: 'Data de Retirada',
      files: 'Documentos',
      remarks: 'Comentários',
      special_quote: 'Cotação Especial',
      requoted: 'Cotando novamente',
      expired: 'Cotação expirada',
      freight_types: 'Tipo de carga',
      special_quote_additional_info: 'Informações adicionais para a cotação especial',
      support: 'Contatos',
      suppliers: 'Fornecedores',
      response: 'Resposta',
      description: 'Descrição',
      success: 'Sucesso!',
      booking_success: 'Reserva realizada com sucesso!',
      specialCharges: 'Cargas especiais',
      active: 'Ativo',
      downloadChat: 'Baixar Chat',
      yourWebHookHasBeenCreated: 'Seu webhook foi criado',
      serverError: 'Erro do servidor, tente novamente',
      atention: 'Atenção',
      titleNotFoundInsurance: 'Tipo de carga não encontrado para cotação de seguro',
      descriptionNotFoundInsurance: 'Prezado cliente, Sua cotação de seguro exige que alguém de nossa equipe de atendimento ao cliente entre em contato com você. Você será contatado em breve.',
      physicalPerson: 'Pessoa física',
      moralPerson: 'Pessoa moral',
      titleOtherCountry: 'O México não é origem nem destino nas cotações de seguros.',
      descriptionOtherCountry: 'Prezado cliente, Sua cotação de seguro exige que alguém de nossa equipe de atendimento ao cliente entre em contato com você. Você será contatado em breve.',
      titleValueMerchExceeded: 'Exigência de aprovação de seguro para Valor da mercadoria',
      descriptionValueMerchExceeded: 'Prezado cliente, Sua cotação de seguro exige que alguém de nossa equipe de atendimento ao cliente entre em contato com você. Você será contatado em breve.'
    },
    headers: {
      booking: 'Resumo',
      detailed_information: 'Informações detalhadas',
      itinerary: {
        route: 'Rota',
        flight: 'Voo',
        etd: 'ETD',
        eta: 'ETA',
        total: 'Total',
        subtotal: 'Subtotal',
        discount: 'Desconto',
        rate_with_discount: 'Tarifa com Desconto',
        rate: 'Tarifa',
        taxes: 'Impostos',
        cw: 'Peso de Carga',
        density_discount: 'Desconto por densidade',
        flash_discount: 'Desconto relâmpago'
      },
      quotation_option: {
        arrange: 'Organizar por',
        transit: 'Tempo em trânsito (dias)',
        gross_weight: 'Peso bruto (kg)',
        chargeable_weight: 'Peso carregável (kg)',
        rate_per_kg: 'Tarifa por kg (USD/kg)',
        total: 'Total (USD)',
        cbm: 'CBM'
      },
      fee_breakdown: {
        text: 'A cotação inclui o seguinte:',
        gross_weight: 'Peso bruto (kg)',
        volume_weight: 'Volume carregável',
        chargeable_weight: 'Peso carregável (kg)',
        rate: 'Tarifa por kg (USD/kg)',
        subtotal: 'Subtotal (USD)',
        tax: 'Imposto (USD)',
        total: 'Total (USD)',
        regular: 'Regular',
        discount: 'Desconto',
        total_discount: 'Total com desconto (USD)',
        final: 'Final'
      },
      frequency: {
        route: 'Rota',
        flights: 'Voos',
        frequency: 'Frequência',
        remark: 'Comentário'
      },
      logicoins: 'Logikoins trocados',
      new_total: 'Novo Total',
      edit_supplier: 'Atualizar Fornecedor',
      create_supplier: 'Adicionar Novo Fornecedor',
      edit_user: 'Atualizar Usuário',
      create_user: 'Adicionar Novo Usuário',
      edit_fiscal_address: 'Atualizar Endereço Fiscal',
      create_fiscal_address: 'Adicionar Endereço Fiscal',
      charge: 'Carga',
      filterSalesByStatus: 'Filtrar vendas por Estado',
      markAsRead: 'Marcar como lido',
      booked: 'Reservada',
      selected: 'Selecionada',
      no_selected: 'Não selecionado',
      expired: 'Expirada',
      shipments: 'Embarques',
      money: 'Dinheiro',
      deleted: 'Deletado!',
      error: 'Erro!',
      active: 'Ativa',
      create_group: 'Crear Grupo',
      edit_group: 'Editar Grupo',
      quote_saved: 'Sua cotação foi salva com sucesso',
      special_quotes: {
        revision: 'Revisão',
        process: 'Processo',
        refused: 'Recusado',
        see: 'Ver',
        expired: 'Expirado',
        cancelled: 'Cancelado',
        selected: 'Selecionado',
        sent: 'Enviado',
        rejected: 'Rejeitado',
        booked: 'Reservado',
        approved: 'aprovado'
      },
      my_quotations: {
        tab_quotations: 'Cotações',
        tab_special_quotations: 'Cotações especiais',
        tbl_gw: 'GW (kg)',
        tbl_validity: 'Vigencia',
        tbl_actions: 'Ações'
      },
      preparingQuote: 'Muito obrigado pela sua solicitação de orçamento.',
      preparingQuoteText: 'Você receberá seu orçamento por e-mail no dia ',
      before8am: ' antes das 8h.',
      sentInfo: ' Sua cotação foi enviada para ',
      contactInfo: ' em caso de que este e-mail precise de atualização, entre em contato: '
    },
    menu: {
      dashboard: 'Painel',
      quote: 'Cotar',
      my_quotations: 'Minhas cotações',
      my_bookings: 'Reservas atuais',
      my_old_bookings: 'Reservas antigas',
      suppliers: 'Fornecedores',
      users: 'Usuários',
      groups: 'Grupos',
      blog: 'Blog',
      logikoins: 'Logikoins',
      financials: 'Pagamentos',
      support: 'Contatos',
      webhooks: 'Webhooks',
      active: 'Activo'
    },
    fields: {
      search: 'Pesquisar',
      actions: 'Ações',
      login: {
        email: 'Email',
        password: 'Senha',
        rememberme: 'Lembre-me',
        forgot: 'Você esqueceu sua senha?',
        dont_account: 'Não tem conta ainda?',
        register: 'Cadastre-se agora',
        return: 'Voltar ao site',
        title: 'LGK Aéreo'
      },
      register: {
        text: 'Preencha os campos a seguir para criar sua conta',
        full_name: 'Nome completo',
        first_name: 'Nome (s)',
        last_name: 'Sobrenomes',
        company: 'Companhia',
        phone: 'Telefone',
        zone: 'Zona',
        email: 'Email',
        password: 'Senha',
        confirm_password: 'Confirme a senha',
        button: 'CRIAR CONTA',
        have_account: 'Você já tem uma conta?',
        sign_in: 'Inicie sessão'
      },
      header: {
        profile: 'Editar perfil',
        logikoins: 'Logikoins',
        support: 'Suporte',
        logout: 'Fechar sessão',
        drawer: {
          notifications: 'Notificações',
          markAsRead: 'Marcar como lidas',
          all: 'Todos',
          unread: 'Não lidas | Não lidas ({count}) | Não lidas ({count})',
          read: 'Lidas | Lidas ({count}) | Lidas ({count})'
        },
        exchange_informative: 'Tipo de câmbio informativa'
      },
      dashboard: {
        get_started: 'Comece agora',
        quote: 'Faça sua cotação',
        shipment_status: 'Embarques actuales',
        help_from: 'Ajuda de um representante',
        welcome: 'Bem-vindo!',
        latest_quotes: 'Últimas cotações'
      },
      quotation: {
        origin: 'Origem',
        destination: 'Destino',
        pickup_date: 'Carga disponível',
        incoterm: 'Incoterm',
        number_pieces: 'Número de peças',
        gw: 'GW',
        cbm: 'CBM',
        weight: 'Peso',
        weight_piece: 'Peso por peça',
        length: 'Largura',
        width: 'Comprimento',
        height: 'Altura',
        freight_type: 'Tipo de carga',
        pass_through_usa: 'Trânsito permitido via EUA',
        pieces: 'Peças',
        pieces_placeholder: 'Digite o número de peças',
        code: 'Código',
        status: 'Estado',
        vw: 'VW',
        total: 'Total',
        date: 'Data de disponibilidade de carga',
        expired: 'Expira em (dias)',
        action: 'Ação',
        chargeable_weight: 'Peso carregável',
        gross_weight: 'Peso de Carga (kg)',
        flights: 'Voos',
        frequency: 'Frequência',
        date_quote: 'Data da cotação',
        rate: 'Tarifa',
        type_of_measure: 'Cotar por',
        dimensions: 'Peça',
        volume: 'Volume',
        route: 'Rota',
        lowestPrice: 'Menor Preço',
        fastestTransitTime: 'Tempo de trânsito mais rápido',
        system_conversion: 'Digite as dimensões por peça, o sistema converterá automaticamente o volume.',
        days: 'dias'
      },
      insurance: {
        insurance: 'Seguro',
        name: 'Nome do destinatário/Beneficiário',
        placeholder_name: 'Digite o nome',
        origin: 'Origem',
        placeholder_origin: 'Insira uma origem',
        destiny: 'Destino',
        placeholder_destiny: 'Insira um destino',
        typeBeneficiary: 'Tipo de beneficiário',
        carrier: 'Operadora',
        type: 'Tipo de carga',
        category: 'Categoria',
        placeholder_category: 'Selecione a categoria',
        value: 'Valor da mercadoria (USD)',
        placeholder_value: '$',
        description: 'Descrição da mercadoria',
        placeholder_description: 'Insira a descrição',
        pieces: 'Peças',
        placeholder_pieces: 'Digite o número de peças',
        gw: 'GW (kg)',
        cbm: 'CBM',
        chargable_weight: 'Peso carregável (kg)',
        weight: 'Peso (por peça)',
        length: 'Comprimento',
        width: 'Largura',
        height: 'Altura',
        placeholder_kg: 'kg',
        placeholder_m3: 'm3',
        placeholder_cm: 'cm',
        volume: 'Volume',
        dimensions: 'Dimensões (por peça)',
        download_tc: 'Baixe os termos e condições',
        quote: 'Cotar',
        checkbox: 'Não consigo encontrar o tipo de carga na lista',
        zipcode_checkbox: 'Não encontrei o CEP na lista',
        flight_date: 'Data do voo'
      },
      changePassword: {
        password: 'Senha',
        new_password: 'Nova Senha',
        new_password_confirmed: 'Confirmação Nova Senha'
      },
      suppliers: {
        tax_id: 'CPF',
        company_name: 'Nome da Empresa',
        address: 'Endereço',
        city: 'Cidade',
        country: 'País',
        representative_name: 'Nome do representante',
        representative_phone: 'Telefone do representante',
        representative_email: 'E-mail do representante',
        zip_code: 'Código de Endereçamento Postal',
        client_id: 'ID Cliente',
        type: 'Tipo'
      },
      aforder: {
        code: 'Código de reserva',
        your_order: 'Número de ordem:',
        commercial_reference: 'Código de embarque',
        status: 'Status',
        confirmation: 'Confirmação',
        authorization: 'Autorização',
        canceled: 'Cancelado',
        deadline: 'Data Limite',
        eta_warehouse: 'ETA Warehouse',
        mawb: 'MAWB',
        hawb: 'HAWB',
        eta: 'ETA',
        mawb_shipper_id: 'MAWB Expedidor',
        mawb_consignee_id: 'MAWB consignatario',
        hawb_shipper_id: 'HAWB Expedidor',
        hawb_consignee_id: 'HAWB Destinatário',
        consolidated: 'Consolidado',
        picker: 'Coletador',
        origin: 'Origem',
        destination: 'Destino',
        route: 'Rota',
        incoterm: 'Incoterm',
        flight_date: 'Data do Voo',
        reserve_date: 'Data da Reserva',
        pieces: 'Peças',
        weight: 'Peso',
        cbm: 'CBM',
        total_cost: 'Custo Total',
        type: 'Tipo',
        amount: 'Quantia',
        write: 'Escreva..',
        date: 'Encontro',
        tracking: 'Tracking',
        progress: 'Em Curso',
        finalized: 'Finalizado'
      },
      user: {
        avatar: 'Avatar',
        name: 'Nome',
        email: 'Email',
        password: 'Senha',
        confirm_password: 'Confirmar senha',
        roles: 'Funções',
        update: 'Atualizado',
        groups: 'Grupos',
        change_image: 'Mudar imagem'

      },
      client: {
        invoicing: {
          days: 'Dias',
          day: 'Dia',
          documents: 'Documentos incluídos no email',
          fiscal_information: 'Informação Fiscal',
          cfdi_use: 'Uso CFDI',
          payment_method: 'Forma de Pagamento'
        }
      },
      webhooks: {
        name: 'Nome',
        event: 'Evento',
        uri: 'Uri',
        api_token: 'Api Token',
        total_requests: 'Solicitações',
        method: 'Método',
        request_data: 'Dados de Solicitação',
        response_data: 'Dados de Resposta',
        response_status_code: 'Código de Resposta',
        date: 'Data'
      },
      forgotPassword: {
        email: 'Email'
      },
      invoicing: {
        folio: 'Referência do cliente',
        currency: 'Moeda',
        status: 'Status',
        doc_date: 'Data Doc',
        due_date: 'Data Due',
        payment_date: 'Data do pagamento',
        cancellation_date: 'Data de Cancelamento',
        subtotal: 'Subtotal',
        total: 'Total',
        pending_balance: 'Saldo Pendente'
      },
      logikoins: {
        title: 'O que são Logikoins?',
        paragraph1: 'São moedas virtuais que você poderá usar para pagar embarques.',
        paragraph2: 'Para obtê-los, você só precisa fazer o que faz, porque a cada embarque que você transportar conosco, você receberá Logikoins.',
        paragraph3: 'É por isso que quanto mais embarques você mover, mais Logikoins terá.',
        title_levels: 'Níveis',
        levels_paragraph: 'Estamos buscando ter um melhor relacionamento com você, reconhecendo sua lealdade. Temos 4 níveis diferentes que você pode alcançar dependendo dos movimentos que fizer conosco. Em cada nível você terá acesso a tarifas preferenciais e espaços exclusivos.',
        amount: 'Quantia',
        description: 'Descrição',
        date: 'Data',
        information: 'Não há informações',
        zeppelin: '1. Zeppelin',
        zeppelin_text: 'Bem-vindo! Você acabou de iniciar a viagem em nossa plataforma. Como novo cliente, oferecemos 10 Logikoins que você pode trocar em seus novos embarques. Continue fazendo reservas para subir de nível.',
        plane: '2. Avião',
        plane_text: 'Você obtém esse nível acumulando 10 embarques ou US$ 30.000 em um período de 6 meses, o que ocorrer primeiro. Para manter este nível, você terá que continuar com as mesmas operações durante o próximo período de 6 meses.',
        jet: '3. Jato',
        jet_text: 'Você obtém esse nível acumulando 20 embarques ou US$ 60.000 em um período de 6 meses, o que ocorrer primeiro. Para manter este nível, você terá que continuar com as mesmas operações durante o próximo período de 6 meses.',
        space_ship: '4. Nave Espacial',
        space_ship_text: 'Você obtém esse nível acumulando 40 embarques ou US$ 120.000 em um período de 6 meses, o que ocorrer primeiro. Para manter este nível, você terá que continuar com as mesmas operações pelo próximo período de 6 meses.',
        current_level: 'Nível atual',
        zeppelin_name: 'Zeppelin',
        plane_name: 'Avião',
        jet_name: 'Jato',
        space_ship_name: 'Nave Espacial',
        commercial_reference: 'Código Cliente'
      },
      notifications: {
        status: 'Status',
        title: 'Título',
        text: 'Texto',
        read_at: 'Lido em'
      },
      booking: {
        title: 'Reserva',
        quote: 'Cotação',
        route: 'Rota',
        quotation_code: 'Código da cotação',
        transit_time: 'Tempo total de trânsito',
        transit_time_day: '0 dias | 1 dia | {count} dias',
        air: 'Voo',
        legend: 'Lembre-se de que o tempo de expiração da cotação é: {days_to_expire} dias',
        itinerary: 'Itinerário',
        flight: 'Voo',
        rate_breakdown: 'Discriminação  de Tarifas',
        legend_rate_breakdown: 'A tarifa inclui: ',
        exchange_logikoins: 'Troca Logikoins',
        max_logikoins_to_use: 'Uso máximo de logikoins: ',
        first_remark: 'O desconto por volume só é válido para as dimensões e pesos inseridos',
        logikoins_to_use: 'Uso máximo de logikoins: {logikoins}'
      },
      show_aforder: {
        discount: 'Desconto',
        summary: 'Resumo',
        origin: 'ORIGEM:',
        destination: 'DESTINO:',
        route: 'ROTA:',
        pickup_date: 'DATA DE RETIRADA:',
        estimated_departure: 'PARTIDA ESTIMADA:',
        estimated_arrival: 'CHEGADA ESTIMADA:',
        transit_time: 'TEMPO EM TRÂNSITO:',
        cargo: 'Carga',
        number_of_pieces: 'Nº DE PEÇAS:',
        gross_weight: 'PESO BRUTO (kg):',
        volume_weight: 'PESO VOLUMÉTRICO (kg):',
        cbm: 'CBM',
        chargeable_weight: 'PESO TARIFADO (kg):',
        type: 'TIPO',
        length: 'LARGURA',
        width: 'COMPRIMENTO',
        height: 'ALTURA',
        weight: 'PESO',
        charges: 'Encargos',
        total: 'TOTAL:',
        rate: 'TARIFA:',
        chargeable_weight_charges: 'PESO TARIFADO:',
        comments: 'COMENTÁRIOS',
        no_comments: 'Não tem comentários registrados',
        message: 'Mensagem',
        legend_comments: 'Escreva sua mensagem aqui, a área de operações responderá em breve',
        status_history: 'Histórico de Status',
        documents: 'Documentos',
        itinerary: 'Itinerário',
        direct_awb: 'Direto AWB',
        mawb_consignee: 'DESTINATÁRIO MAWB',
        hawb_consignee: 'CONSIGNATÁRIO HAWB',
        hawb_shipper: 'EXPEDIDOR HAWB',
        shipment_details: 'Detalhes do Embarque',
        flight_date: 'DATA DO VOO:',
        flight: 'VOO:',
        selling_date: 'DATA DA VENDA:',
        payment_options_on_the_hawb: 'OPÇÕES DE PAGAMENTO NO HAWB:',
        available: 'DISPONÍVEL:',
        deadline: 'DATA LIMITE:',
        authorization: 'AUTORIZAÇÃO:'
      },
      status_history: {
        status: 'Status',
        date: 'Data',
        by: 'Por'
      },
      documents: {
        name: 'Nome',
        type: 'Tipo',
        actions: 'Ações'
      },
      itinerary: {
        origin: 'Origem',
        destination: 'Destino',
        number: 'Número',
        pieces: 'Peças'
      },
      history_quotations: {
        title: 'HISTÓRICO DE COTAÇÕES',
        code: 'Código',
        pieces: 'Peças',
        volume_weight: 'Peso Volumétrico',
        gross_weight: 'Peso Bruto',
        cbm: 'CBM',
        chargeable_weight: 'Peso Carregável',
        type: 'Tipo de carga',
        transit_usa: 'Trânsito via EUA permitido',
        rate: 'Tarifa',
        total_sale: 'Total',
        created_at: 'Criado Por',
        unit: 'Unidade',
        comments: 'Comentários',
        quantity: 'Quantidade',
        retained_taxes: 'Impostos Retidos',
        transferred_taxes: 'Impostos Transferidos',
        subtotal: 'Subtotal',
        total: 'Total',
        total_usd: 'Total USD'
      },
      old_bookings: {
        gross_weight: 'Peso Bruto (kg)',
        volume_weight: 'Peso volumétrico (kg)',
        chargeable_weight: 'Peso Tarifado (kg)',
        mawb_shipper: 'EXPEDIDOR MAWB',
        deliveries: {
          title: 'Entregas',
          truck: 'Caminhão',
          quantity: 'Quantidade',
          operator: 'Operador'
        },
        sales: {
          title: 'Venda',
          currency: 'Moeda',
          type: 'Tipo',
          exchange_rate: 'Tipo de Câmbio',
          comments: 'Comentários',
          sale_concept: 'Conceito da Venda',
          quantity: 'Quantidade',
          rate: 'Tarifa',
          unit: 'Unidade',
          transferred_taxes: 'Impostos Transferidos',
          retained_taxes: 'Impostos Retidos',
          subtotal: 'Subtotal',
          total: 'Total'
        }
      },
      blog: {
        air_import: {
          title: 'Manual de Vendas de Importação Aérea',
          text: 'Uma pergunta comum dos agentes de carga é qual tarifa devo oferecer ao meu cliente? A resposta deve considerar vários fatores como:',
          first: 'Tipo de carga de produtos',
          second: 'Tipo de indústria',
          third: 'Tamanho da empresa',
          text2: 'Como parte de nosso compromisso com os agentes de carga, realizamos um estudo para responder a essa pergunta básica. Baixe o documento a seguir para saber mais.'
        },
        how_quote: {
          title: 'Como fazer uma cotação?',
          text: 'Tem alguma dúvida para fazer uma cotação? Siga estes passos simples e obtenha cotações incríveis.'
        }
      },
      financials: {
        invoicing: {
          title: 'FATURAMENTO',
          summary: 'Resumo',
          fiscal_address: 'Endereços Fiscais'
        },
        billing_information: {
          title: 'DADOS DE FATURAMENTO',
          subtitle: 'Dados de Faturamento',
          cfdi_use: 'Uso CFDI : ',
          payment_method: 'Forma de Pagamento:',
          documents: 'Documentos:',
          fiscal_information: 'Informação Fiscal:',
          periodicity: 'Periodicidade:'
        },
        bank_accounts: {
          title: 'CONTAS BANCÁRIAS',
          subtitle: 'Contas Bancárias',
          company_information: 'Dados da empresa',
          business_name: 'Razão Social:',
          rfc: 'Cadastro de Pessoa Física (CPF):',
          fiscal_address: 'Domicílio Fiscal:',
          phone: 'Telefone:',
          email: 'Email:',
          contact: 'Contato: ',
          freight_payment: 'Pagamento Frete',
          bank: 'Banco: ',
          beneficiary: 'Beneficiário: ',
          account_number: 'Número de Conta: ',
          branch_name: 'Nome da Filial:',
          branch_number: 'Número da Filial',
          bank_located: 'Estado ou cidade onde o banco está localizado:',
          clabe_interbank: 'CÓDIGO interbancário:',
          currency: 'Moeda:',
          payment_reva: 'Pagamento Revalidação'
        }
      },
      special_quote: {
        origin_country: 'País de origem',
        origin_region: 'Região de origem',
        origin_city: 'Cidade de origem',
        destination_country: 'País de destino',
        destination_region: 'Região de destino',
        destination_city: 'Cidade de destino',
        zip_code: 'Código de Endereçamento Postal',
        deadline: 'Validade',
        nature_charge: 'Natureza da Carga',
        pickup_date: 'Disponível a partir de',
        address: 'Endereço',
        pickup_address: 'Endereço de retirada',
        pickup_address_placeholder: 'Ensira o endereço de retirada',
        other_freight_type: 'Outro',
        destination_airport: 'Aeroporto de destino',
        origin_airport: 'Aeroporto de origem',
        available_date: 'Data de carga disponível',
        available_date_provided: 'Data de carga disponível fornecida',
        available_date_not_provided: 'Data de carga disponível não fornecida',
        available_date_not_provided_warning: 'São concedidas tarifas considerando a tarifa disponível no momento, sujeitas a validade e alteração quando a carga estiver disponível.',
        service: 'Tipo de carga',
        contains_batteries: 'Contém baterias de lítio?',
        commodity: 'Descrição do produto',
        service_warning: 'Para carga DG, forneça um MSDS atualizado. Para a China Continental, é necessário um certificado SRICI/PONY ou um certificado validado por uma organização de certificação chinesa. O MSDS não será válido na China ao gerar a reserva.',
        services_options: {
          general_cargo_stackable: 'Carga Geral / Empilhável',
          general_cargo_no_stackable: 'Carga Geral / Não Empilhável',
          overweight_oversized: 'Excesso de Peso / Sobredimensionado',
          dangerous_goods: 'Mercadorias Perigosas',
          perishable: 'Perecível'
        },
        batteries_options: {
          no_batteries: 'Sem baterias',
          lithium_ion: 'ELI - UN3481 - Baterias de íon de lítio - Seção II',
          lithium_metal: 'ELM - UN3091 - Baterias de metal de lítio - Seção II',
          combination: 'UN3481/UN3091 - combinação - Seção II'
        },
        deadline_arrival: 'Data limite de chegada',
        internal_reference: 'Código de referência interna'
      },
      remarks: {
        remark: 'Comentário',
        enter_remark: 'Escreva seu comentário aqui'
      },
      file: {
        type: 'Tipo',
        file: 'Arquivo',
        comments: 'Comentários',
        attach_file: 'Anexar arquivo'
      },
      support: {
        contact_title: 'Dados de contato',
        text: 'Entre em contato se tiver alguma dúvida.',
        phone: 'Telefone',
        title_quotation_question: 'Tem alguma dúvida para fazer uma cotação?',
        text_quotation_question: 'Siga estes passos simples e obtenha cotações incríveis.',
        show_document: 'Ver documento'
      },
      mega_sale_status: {
        all: 'TODAS',
        paid: 'PAGAS',
        pending: 'PENDENTES',
        canceled: 'CANCELADAS',
        cancellation: 'CANCELAMENTO EM PROCESSO',
        partial_paid: 'PAGAS PARCIALMENTE'
      },
      address: {
        legal_name: 'Nome Legal',
        tax_id: 'CPF',
        city: 'Cidade',
        street: 'Rua',
        no_ext: ' N°. Ext.',
        colony: 'Bairro',
        municipality: 'Município',
        state: 'Estado',
        zip_code: 'Código de Endereçamento Postal',
        country: 'País',
        no_int: 'N°. Ext.',
        alias: 'Apelido',
        responsable: 'Responsável',
        reference: 'Referências',
        locality: 'Localidade',
        alias_placeholder: 'Dados para identificar o endereço.'
      },
      group: {
        name: 'Nome',
        users: 'Usuários'
      }
    },
    messages: {
      question_contact: 'Você tem alguma dúvida sobre cotações?',
      text_contact: 'Contate nossos consultores',
      login_header: 'Por favor, preencha seus dados abaixo para fazer login.',
      quotation_option: 'Não encontramos opções para você. Por favor, envie-nos o seu pedido como Cotação Especial',
      login_session: 'Complete los siguientes datos para iniciar sesión.',
      change_password: 'Se você quiser usar este aplicativo, você precisa alterar sua senha',
      password_changed: 'É necessário fazer login novamente sempre que a senha for alterada',
      session_expired: 'Sua senha expirou, você precisa fazer login novamente para alterá-la',
      logicoins_to_use: 'Você pode usar {logicoins_to_use} logikoins',
      gain_logicoins: 'Reserve agora e ganhe {gain_logicoins} Logikoins',
      forgot_password: 'Se você esqueceu sua senha você precisa redefini-la, escreva seu e-mail abaixo e você receberá um e-mail para realizar esta ação',
      reset_password: 'Para redefinir sua senha você precisa preencher o seguinte formulário',
      expire_days: 'Tempo restante para sua cotação expirar: {expire_days} dias',
      direct_awb: 'Para usar o preenchimento automático, preencha as informações neste link:',
      disclaimer_oldbooking: 'Prezado cliente, bem-vindo à nova plataforma logikoss.com.\n' + 'Os detalhes dos envios reservados na versão anterior podem ser encontrados aqui.',
      membership_next_level: 'Se você subisse para a categoria {next_membership} estaria pagando por este embarque',
      saving_money: 'economizando {saving_money} USD',
      empty_remarks: 'Não há comentários registrados.',
      placeholder_comment: 'Escriba su mensaje aquí, nuestro equipo de operaciones responderá tan pronto sea posible.',
      booked: 'Esta cotação já foi reservada',
      under_authorization: 'Esta cotação está aguardando aprovação',
      options: 'Temos {option} opções para você',
      noOptionsFCA: 'Não há opções de FCA',
      optionsFCA: 'Temos {option} opções FCA para você',
      optionsEXW: 'Temos {option} opções EXW para você',
      options_single: 'Temos {option} opção para você',
      options_singleFCA: 'Temos {option} opção FCA para você',
      options_singleEXW: 'Temos {option} opção EXW para você',
      discount_availability: 'Desconto sujeito a disponibilidade',
      booking_before: 'Reserve antes de:',
      tooltipCreateWebhook: 'Criar Webhook',
      tooltipEdit: 'Editar',
      tooltipDelete: 'Excluir',
      tooltipWebhookCredentials: 'Credenciais webhook',
      aforderStatusChanged: 'Notificação quando há uma mudança de status de algum embarque',
      aforderWeightsUpdated: 'Notificação quando há atualização de pesos de algum embarque',
      aforderItineraryUpdated: 'Notificação quando há mudança de itinerário de algum embarque',
      aforderQuotationSalesUpdated: 'Notificação quando há uma atualização na cotação de uma venda',
      aforderUploadFile: 'Notificação quando for adicionado um documento de algum embarque',
      aforderUpdated: 'Notificação quando há uma atualização de algum embarque',
      aforderAuthorized: 'Notificação quando algum embarque  é autorizado',
      aforderDeliveryUpdated: 'Notificação quando há atualização de entrega de algum embarque',
      requoted: 'Foi feita uma nova cotação devido à data de expiração.',
      expired: 'Sua cotação expirou. Favor cotar novamente para obter novos preços.',
      thisQuotationHasBeenSavedWithCode: 'Essa cotação foi salva com o código',
      itWillBeValidFor: 'Será válido para',
      areYouSure: 'Você tem certeza?',
      confirmBookingText1: 'A rota selecionada utiliza voos de passageiros. Certifique-se de que as dimensões máximas por peça são',
      bookingConfirmedText1: 'Este envio foi reservado sob o código:',
      bookingConfirmedText2: 'Você pode acompanhar as atualizações no tracking',
      stpRemark: 'Se a carga contiver: Equipamentos de áudio e som, equipamento elétrico, eletrodomésticos ou motores, custos extras podem ser aplicados em até',
      allRightsReserved: 'Todos os direitos reservados',
      nextLevelShipments: 'Você possui {current}, faltam somente {missing} embarques para alcançar o nível Avião.',
      nextLevelAmount: 'Você possui USD {current}, faltam somente USD {missing} USD para alcançar o próximo nível',
      dataHasBeenDeleted: 'Os dados foram excluídos.',
      dataHasNotBeenDeleted: 'Os dados não foram excluídos.',
      youWontBeAbleToRevertThis: 'Não poderá reverter isso',
      noOptions: 'Não há opções para sua cotação',
      stpSend: 'Sua cotação especial foi enviada',
      noSTPSaved: 'Nenhuma cotação foi salva',
      quoteSaved: 'Sua cotação foi salva',
      whichGroupQuoteAssigned: 'A qual grupo esta cotação será atribuída?',
      firstSelectDateItineray: 'Primeiro você deve selecionar uma data do itinerário',
      quoteHasBeenSentForAuth: 'Esta cotação foi enviada para autorização',
      defaultAirportError: 'Entre em contato com o administrador para validar a origem.'
    },
    countries: {
      mexico: 'México',
      colombia: 'Colômbia',
      ecuador: 'Equador',
      chile: 'Chile',
      brasil: 'Brasil'
    },
    support: {
      sales_director: 'Diretor de Vendas',
      commercial_director: 'Diretora Comercial',
      general_manager: 'Gerente Geral',
      bussiness_development: 'Desenvolvimento de Negócios'
    },
    screnNewQuotation: {
      departure_city: 'Cidade de Origem',
      detination_city: 'Cidade de Destino',
      quote_edit: 'Editar',
      new_quote: 'Nova cotação',
      pieces: 'Peças',
      gross_weight: 'Peso Bruto (kg)',
      cbm: 'CBM (m3)',
      loadable_weight: 'Peso Carregável (kg)',
      density: 'Densidade (kg/CBM)',
      download_quotation: 'Baixar cotação',
      searchResult: 'Seus resultados de pesquisa',
      options: 'Temos <span style="font-weight: 500">{option}</span> opções para você',
      noOptionsFCA: 'Não há opções de FCA',
      optionsFCA: 'Temos <span style="font-weight: 500">{option}</span> opções FCA para você',
      optionsEXW: 'Temos <span style="font-weight: 700">{option}</span> opções EXW para você',
      options_single: 'Temos <span style="font-weight: 500">{option}</span> opção para você',
      options_singleFCA: 'Temos <span style="font-weight: 500">{option}</span> opção FCA para você',
      options_singleEXW: 'Temos <span style="font-weight: 700">{option}</span> opção EXW para você',
      flightDate: 'Data do voo',
      quotation_option: 'Não encontramos opções para você. Por favor, envie-nos o seu pedido como Cotação Especial',
      consolidation: 'Consolidado',
      route: 'Rota',
      airline: 'Linha aérea',
      discount_density: 'DESCONTO DE DENSIDADE',
      discount_density_detail: 'Válido para detalhes, data e rota descritos, MAWB consignado a Logikoss',
      volume_discount: 'DESCONTO VOLUMÉTRICO',
      volume_discount_detail: 'Desconto para carga volumétrica aplica-se para os detalhes especificados e consignados a Logikoss',
      consolidation_discount: 'BENEFÍCIO DE CONSOLIDAÇÃO',
      loose_charge: 'DESCONTO DE CARGA SOLTA',
      capacity: 'Capacidade Total',
      available_capacity: 'Capacidade Disponível',
      pickup: 'Coleta',
      more_information: 'Mais informação',
      table: {
        rate: 'Avaliar',
        cost: 'Total',
        normal: 'Normal',
        discount: 'Discontos',
        final: 'Final'
      },
      remark_consolidation: 'Benefício de consolidação válido para detalles, data e rota especificados. MAWB consignado a Logikoss.'
    },
    newTrackingPresentation: {
      selectAnOrderNumber: 'Selecione um número de pedido',
      noDataAvailable: 'Não há dados disponíveis',
      cargoHistory: 'Histórico',
      cargoArrived: 'Sua carga chega em',
      origin: 'Origem',
      destination: 'Destino',
      shipmentDetails: 'Detalhes do Embarque',
      incoterm: 'Incoterm',
      weight: 'Peso',
      chargeableWeight: 'Peso Carregável (kg)',
      density: 'Densidade',
      pieces: 'Peças',
      remark: 'Os detalhes da carga são diferentes da reserva inicial',
      viewDetails: 'Ver histórico',
      cargoDetailHistory: 'Histórico de itinerário',
      dateWhenChangeWasMade: 'Data em que a alteração foi feita',
      comments: 'Comentários',
      backToCurrentSchudule: 'Voltar ao itinerário atual',
      noChangesYet: 'Ainda não há alterações',
      galleryMedia: 'Galeria de mídia',
      schedule: 'Itinerário',
      shareTracking: 'Compartilhar rastreamento',
      shareTrackingByEmail: 'Compartilhar rastreamento por e-mail',
      sendByEmail: 'Enviar por e-mail',
      downloadPDF: 'Baixar PDF',
      scheduleHistory: 'Histórico de itinerário',
      scheduleBottomText: 'Este itinerário é diferente do reservado',
      ps: 'PS',
      kg: 'Kg',
      fn: 'Voo/Truck',
      sheduleDivider: 'Carga dividida: A carga foi dividida nas seguintes rotas',
      sendByWhatsapp: 'Enviar por Whatsapp',
      sendWhatsappMessage: 'Enviar mensagem de Whatsapp',
      send: 'Enviar',
      client: 'Cliente',
      whatsappMessage: 'No PDF você pode encontrar o status atual da remessa',
      download: 'Baixar',
      itsEmpty: 'vazio',
      of: 'de',
      cargoOnBoard: 'Sua carga embarcou ',
      cargoNoOnBoard: 'Sua carga não embarcou',
      messageP1: 'Estimado cliente',
      messageP2: 'Receba em anexo o rastreamento de sua remessa',
      messageP3: 'Com as seguintes características',
      subject: 'Assunto',
      to: 'Para',
      lastSystemUpdate: 'Última atualização do sistema',
      withoutItineraryCargoNotReady: 'Sem itinerário, a carga não está pronta'
    },
    insurance: {
      modal: {
        title: 'Cotar seguro de frete',
        title2: 'Confirmar seguro de envio',
        title3: 'Apólice de seguro',
        title4: 'Cotação de seguro de remessa',
        subtitle: 'Seguro de Embarque',
        subtitle2: 'Seu seguro foi contratado com sucesso',
        subtitle3: 'Sua cotação de seguro foi salva com sucesso',
        text1: 'Cobertura de seguro de remessa:',
        text2: 'Agora você pode ver suas cotações de seguros em minhas cotações',
        step1: 'Preço',
        step2: 'Contratando',
        step3: 'Confirmação',
        here: 'aqui',
        tc: 'Termos e condições',
        download_tc: 'Baixe os termos e condições',
        download_insurance: 'Baixe sua apólice de seguro',
        title_alert: 'Confirmar seguro',
        message_alert: 'Tem certeza de que deseja confirmar a compra do seu seguro de remessa?',
        continue: 'Continuar citando',
        btn_continue: 'Continuar',
        btn_save: 'Salvar',
        btn_cancel: 'Cancelar',
        btn_back: 'Voltar',
        btn_hire: 'Contratar',
        btn_confirm: 'Confirme',
        btn_create: 'Criar Usuário',
        go_to_insurance: 'Vá para minhas cotações de seguros',
        go_to_hire: 'Acesse meu seguro contratado',
        bnt_finish: 'Terminar',
        disclaimer: 'ESCLARECIMENTO: OS TERMOS QUE APARECEM NA LÍNGUA INGLESA E QUE ESTÃO MENCIONADOS NESTE MÓDULO DE SEGURO PARA COTAÇÃO E EMISSÃO DO CERTIFICADO DE SEGURO E/OU QUALQUER DOCUMENTO E/OU PROCESSO RELACIONADO A QUESTÕES DE SEGURO SÃO UMA TRADUÇÃO GRATUITA E DE CORTESIA PARA O INGLÊS, PORTANTO SEMPRE PARA QUAISQUER DISCREPÂNCIAS E OBSERVAÇÕES QUE POSSAM EXISTIR, PREVALECERÁ SEMPRE A VERSÃO EM ESPANHOL DA LÍNGUA, PORQUE É UMA TRADUÇÃO ORIGINAL DO ESPANHOL.'
      },
      quoteTable: {
        tab: 'Cotação de seguro',
        noQuote: 'Citação Não.',
        origin: 'Origem',
        destiny: 'Destino',
        value: 'Valor da mercadoria (USD)',
        total: 'Seguro Total',
        expires: 'Expira em',
        tyc: 'Termos e condições',
        action: 'Ação',
        download: 'Baixar',
        confirm: 'Confirme'
      },
      bookingTable: {
        tab: 'Seguros contratados',
        tabAforder: 'Reservas atuais',
        noQuote: 'Citação Não.',
        noPolicy: 'Não. do certificado',
        origin: 'Origem',
        destiny: 'Destino',
        value: 'Valor das mercadorias',
        date: 'Data da reserva',
        insuranceCarrier: 'Seguradora',
        codeClient: 'Código do cliente',
        actions: 'Guia de Danos'
      },
      general: {
        quote: 'Cotação de seguro',
        insuranceHired: 'Seguro contratado',
        insuranceQuoted: 'Seguro cotado'
      }
    }
  }
}
